import * as v from "react";
import fe, { useContext as kn, useMemo as Rs, useRef as Vs, useEffect as js } from "react";
import { j as y } from "./jsx-runtime-3tyXYecC.mjs";
import { f } from "./index-LyFokDcn.mjs";
import { p as $s, T as Ws, b as Dt, u as ur, c as Hs, m as It } from "./tss-DN0acMKN.mjs";
import { M as Ys, d as zs } from "./constants-CnFYFetN.mjs";
import { g as we } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { s as L, c as it } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { T as lr } from "./Typography-DfkimCSn.mjs";
import { _ as Bs, g as at } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { T as xn, B as Zs } from "./ButtonBase-BIvHZGlt.mjs";
import { F as Sn } from "./Fade-B7C8Y6jW.mjs";
import { _ as Us, a as _s } from "./inheritsLoose-OI-DR2K6.mjs";
import { f as qs, T as Gs } from "./Transition-4HZvpgGj.mjs";
import { u as Js } from "./useControlled-ZIJRsfP8.mjs";
import { c as Te } from "./createSvgIcon-ButWPptu.mjs";
import { I as Tn } from "./IconButton-BIUHNiXo.mjs";
import { u as On } from "./useForkRef-C_4o__cU.mjs";
import { u as Ks } from "./useId-CK6Kn3Tn.mjs";
import { l as Be } from "./lodash-5ofSKtz3.mjs";
import { B as Qs } from "./body-text-BiQwh5-U.mjs";
import { g as Xs } from "./generate-fabric-classes-CDFy9xEs.mjs";
import { c as ei } from "./index-DkZ16bcJ.mjs";
import { G as ti } from "./grid-row-D1eZQbHo.mjs";
import { F as ri } from "./flex-Cc3osQLf.mjs";
import { I as Zr } from "./icon-button-BxDvkq_l.mjs";
import { D as Cn } from "./date-picker-provider.domain-CocKbrk9.mjs";
import { S as En } from "./select-DjbIs9Ff.mjs";
import { B as Ur } from "./button-CUHBhgeQ.mjs";
import { u as ni } from "./useThemeProps-wW47KG21.mjs";
function ot({
  props: t,
  name: e
}) {
  return ni({
    props: t,
    name: e,
    defaultTheme: $s,
    themeId: Ws
  });
}
function si(t, e) {
  return t.classList ? !!e && t.classList.contains(e) : (" " + (t.className.baseVal || t.className) + " ").indexOf(" " + e + " ") !== -1;
}
function ii(t, e) {
  t.classList ? t.classList.add(e) : si(t, e) || (typeof t.className == "string" ? t.className = t.className + " " + e : t.setAttribute("class", (t.className && t.className.baseVal || "") + " " + e));
}
function _r(t, e) {
  return t.replace(new RegExp("(^|\\s)" + e + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function ai(t, e) {
  t.classList ? t.classList.remove(e) : typeof t.className == "string" ? t.className = _r(t.className, e) : t.setAttribute("class", _r(t.className && t.className.baseVal || "", e));
}
var oi = function(e, n) {
  return e && n && n.split(" ").forEach(function(r) {
    return ii(e, r);
  });
}, Ht = function(e, n) {
  return e && n && n.split(" ").forEach(function(r) {
    return ai(e, r);
  });
}, cr = /* @__PURE__ */ function(t) {
  Us(e, t);
  function e() {
    for (var r, s = arguments.length, i = new Array(s), a = 0; a < s; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)) || this, r.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, r.onEnter = function(o, u) {
      var l = r.resolveArguments(o, u), c = l[0], h = l[1];
      r.removeClasses(c, "exit"), r.addClass(c, h ? "appear" : "enter", "base"), r.props.onEnter && r.props.onEnter(o, u);
    }, r.onEntering = function(o, u) {
      var l = r.resolveArguments(o, u), c = l[0], h = l[1], d = h ? "appear" : "enter";
      r.addClass(c, d, "active"), r.props.onEntering && r.props.onEntering(o, u);
    }, r.onEntered = function(o, u) {
      var l = r.resolveArguments(o, u), c = l[0], h = l[1], d = h ? "appear" : "enter";
      r.removeClasses(c, d), r.addClass(c, d, "done"), r.props.onEntered && r.props.onEntered(o, u);
    }, r.onExit = function(o) {
      var u = r.resolveArguments(o), l = u[0];
      r.removeClasses(l, "appear"), r.removeClasses(l, "enter"), r.addClass(l, "exit", "base"), r.props.onExit && r.props.onExit(o);
    }, r.onExiting = function(o) {
      var u = r.resolveArguments(o), l = u[0];
      r.addClass(l, "exit", "active"), r.props.onExiting && r.props.onExiting(o);
    }, r.onExited = function(o) {
      var u = r.resolveArguments(o), l = u[0];
      r.removeClasses(l, "exit"), r.addClass(l, "exit", "done"), r.props.onExited && r.props.onExited(o);
    }, r.resolveArguments = function(o, u) {
      return r.props.nodeRef ? [r.props.nodeRef.current, o] : [o, u];
    }, r.getClassNames = function(o) {
      var u = r.props.classNames, l = typeof u == "string", c = l && u ? u + "-" : "", h = l ? "" + c + o : u[o], d = l ? h + "-active" : u[o + "Active"], m = l ? h + "-done" : u[o + "Done"];
      return {
        baseClassName: h,
        activeClassName: d,
        doneClassName: m
      };
    }, r;
  }
  var n = e.prototype;
  return n.addClass = function(s, i, a) {
    var o = this.getClassNames(i)[a + "ClassName"], u = this.getClassNames("enter"), l = u.doneClassName;
    i === "appear" && a === "done" && l && (o += " " + l), a === "active" && s && qs(s), o && (this.appliedClasses[i][a] = o, oi(s, o));
  }, n.removeClasses = function(s, i) {
    var a = this.appliedClasses[i], o = a.base, u = a.active, l = a.done;
    this.appliedClasses[i] = {}, o && Ht(s, o), u && Ht(s, u), l && Ht(s, l);
  }, n.render = function() {
    var s = this.props;
    s.classNames;
    var i = _s(s, ["classNames"]);
    return /* @__PURE__ */ fe.createElement(Gs, Bs({}, i, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, e;
}(fe.Component);
cr.defaultProps = {
  classNames: ""
};
cr.propTypes = {};
const Nn = (t) => fe.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 8 14", width: "8", height: "14" }, t),
  fe.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    fe.createElement(
      "g",
      { transform: "translate(-157 -97)" },
      fe.createElement("path", { d: "M165 97 165 111 157 104z" })
    )
  )
);
Nn.displayName = "CaretLeft8x14";
const Fn = (t) => fe.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 8 14", width: "8", height: "14" }, t),
  fe.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    fe.createElement(
      "g",
      { transform: "translate(-191 -97)" },
      fe.createElement("path", { d: "M199 97 199 111 191 104z", transform: "matrix(-1 0 0 1 390 0)" })
    )
  )
);
Fn.displayName = "CaretRight8x14";
class Le extends Error {
}
class ui extends Le {
  constructor(e) {
    super(`Invalid DateTime: ${e.toMessage()}`);
  }
}
class li extends Le {
  constructor(e) {
    super(`Invalid Interval: ${e.toMessage()}`);
  }
}
class ci extends Le {
  constructor(e) {
    super(`Invalid Duration: ${e.toMessage()}`);
  }
}
class nt extends Le {
}
class An extends Le {
  constructor(e) {
    super(`Invalid unit ${e}`);
  }
}
class ie extends Le {
}
class ke extends Le {
  constructor() {
    super("Zone is an abstract class");
  }
}
const g = "numeric", me = "short", X = "long", kt = {
  year: g,
  month: g,
  day: g
}, dr = {
  year: g,
  month: me,
  day: g
}, In = {
  year: g,
  month: me,
  day: g,
  weekday: me
}, fr = {
  year: g,
  month: X,
  day: g
}, hr = {
  year: g,
  month: X,
  day: g,
  weekday: X
}, mr = {
  hour: g,
  minute: g
}, yr = {
  hour: g,
  minute: g,
  second: g
}, gr = {
  hour: g,
  minute: g,
  second: g,
  timeZoneName: me
}, pr = {
  hour: g,
  minute: g,
  second: g,
  timeZoneName: X
}, wr = {
  hour: g,
  minute: g,
  hour12: !1
}, br = {
  hour: g,
  minute: g,
  second: g,
  hour12: !1
}, vr = {
  hour: g,
  minute: g,
  second: g,
  hour12: !1,
  timeZoneName: me
}, Mr = {
  hour: g,
  minute: g,
  second: g,
  hour12: !1,
  timeZoneName: X
}, Dr = {
  year: g,
  month: g,
  day: g,
  hour: g,
  minute: g
}, kr = {
  year: g,
  month: g,
  day: g,
  hour: g,
  minute: g,
  second: g
}, xr = {
  year: g,
  month: me,
  day: g,
  hour: g,
  minute: g
}, Sr = {
  year: g,
  month: me,
  day: g,
  hour: g,
  minute: g,
  second: g
}, Ln = {
  year: g,
  month: me,
  day: g,
  weekday: me,
  hour: g,
  minute: g
}, Tr = {
  year: g,
  month: X,
  day: g,
  hour: g,
  minute: g,
  timeZoneName: me
}, Or = {
  year: g,
  month: X,
  day: g,
  hour: g,
  minute: g,
  second: g,
  timeZoneName: me
}, Cr = {
  year: g,
  month: X,
  day: g,
  weekday: X,
  hour: g,
  minute: g,
  timeZoneName: X
}, Er = {
  year: g,
  month: X,
  day: g,
  weekday: X,
  hour: g,
  minute: g,
  second: g,
  timeZoneName: X
};
function C(t) {
  return typeof t > "u";
}
function Ae(t) {
  return typeof t == "number";
}
function Lt(t) {
  return typeof t == "number" && t % 1 === 0;
}
function di(t) {
  return typeof t == "string";
}
function fi(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function ye() {
  try {
    return typeof Intl < "u" && Intl.DateTimeFormat;
  } catch {
    return !1;
  }
}
function ut() {
  return !C(Intl.DateTimeFormat.prototype.formatToParts);
}
function Pn() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function hi(t) {
  return Array.isArray(t) ? t : [t];
}
function qr(t, e, n) {
  if (t.length !== 0)
    return t.reduce((r, s) => {
      const i = [e(s), s];
      return r && n(r[0], i[0]) === r[0] ? r : i;
    }, null)[1];
}
function Rn(t, e) {
  return e.reduce((n, r) => (n[r] = t[r], n), {});
}
function Ue(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function pe(t, e, n) {
  return Lt(t) && t >= e && t <= n;
}
function mi(t, e) {
  return t - e * Math.floor(t / e);
}
function Ye(t, e = 2) {
  const n = t < 0 ? "-" : "", r = n ? t * -1 : t;
  let s;
  return r.toString().length < e ? s = ("0".repeat(e) + r).slice(-e) : s = r.toString(), `${n}${s}`;
}
function K(t) {
  if (!(C(t) || t === null || t === ""))
    return parseInt(t, 10);
}
function Nr(t) {
  if (!(C(t) || t === null || t === "")) {
    const e = parseFloat("0." + t) * 1e3;
    return Math.floor(e);
  }
}
function Fr(t, e, n = !1) {
  const r = 10 ** e;
  return (n ? Math.trunc : Math.round)(t * r) / r;
}
function lt(t) {
  return t % 4 === 0 && (t % 100 !== 0 || t % 400 === 0);
}
function st(t) {
  return lt(t) ? 366 : 365;
}
function xt(t, e) {
  const n = mi(e - 1, 12) + 1, r = t + (e - n) / 12;
  return n === 2 ? lt(r) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function Ar(t) {
  let e = Date.UTC(
    t.year,
    t.month - 1,
    t.day,
    t.hour,
    t.minute,
    t.second,
    t.millisecond
  );
  return t.year < 100 && t.year >= 0 && (e = new Date(e), e.setUTCFullYear(e.getUTCFullYear() - 1900)), +e;
}
function St(t) {
  const e = (t + Math.floor(t / 4) - Math.floor(t / 100) + Math.floor(t / 400)) % 7, n = t - 1, r = (n + Math.floor(n / 4) - Math.floor(n / 100) + Math.floor(n / 400)) % 7;
  return e === 4 || r === 3 ? 53 : 52;
}
function Qt(t) {
  return t > 99 ? t : t > 60 ? 1900 + t : 2e3 + t;
}
function Vn(t, e, n, r = null) {
  const s = new Date(t), i = {
    hour12: !1,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  r && (i.timeZone = r);
  const a = Object.assign({ timeZoneName: e }, i), o = ye();
  if (o && ut()) {
    const u = new Intl.DateTimeFormat(n, a).formatToParts(s).find((l) => l.type.toLowerCase() === "timezonename");
    return u ? u.value : null;
  } else if (o) {
    const u = new Intl.DateTimeFormat(n, i).format(s);
    return new Intl.DateTimeFormat(n, a).format(s).substring(u.length).replace(/^[, \u200e]+/, "");
  } else
    return null;
}
function Pt(t, e) {
  let n = parseInt(t, 10);
  Number.isNaN(n) && (n = 0);
  const r = parseInt(e, 10) || 0, s = n < 0 || Object.is(n, -0) ? -r : r;
  return n * 60 + s;
}
function jn(t) {
  const e = Number(t);
  if (typeof t == "boolean" || t === "" || Number.isNaN(e))
    throw new ie(`Invalid unit value ${t}`);
  return e;
}
function Tt(t, e, n) {
  const r = {};
  for (const s in t)
    if (Ue(t, s)) {
      if (n.indexOf(s) >= 0) continue;
      const i = t[s];
      if (i == null) continue;
      r[e(s)] = jn(i);
    }
  return r;
}
function Ot(t, e) {
  const n = Math.trunc(Math.abs(t / 60)), r = Math.trunc(Math.abs(t % 60)), s = t >= 0 ? "+" : "-";
  switch (e) {
    case "short":
      return `${s}${Ye(n, 2)}:${Ye(r, 2)}`;
    case "narrow":
      return `${s}${n}${r > 0 ? `:${r}` : ""}`;
    case "techie":
      return `${s}${Ye(n, 2)}${Ye(r, 2)}`;
    default:
      throw new RangeError(`Value format ${e} is out of range for property format`);
  }
}
function Rt(t) {
  return Rn(t, ["hour", "minute", "second", "millisecond"]);
}
const $n = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z_+-]{1,256}(\/[A-Za-z_+-]{1,256})?)?/;
function V(t) {
  return JSON.stringify(t, Object.keys(t).sort());
}
const yi = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], Wn = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], gi = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function Hn(t) {
  switch (t) {
    case "narrow":
      return [...gi];
    case "short":
      return [...Wn];
    case "long":
      return [...yi];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const Yn = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], zn = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], pi = ["M", "T", "W", "T", "F", "S", "S"];
function Bn(t) {
  switch (t) {
    case "narrow":
      return [...pi];
    case "short":
      return [...zn];
    case "long":
      return [...Yn];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const Zn = ["AM", "PM"], wi = ["Before Christ", "Anno Domini"], bi = ["BC", "AD"], vi = ["B", "A"];
function Un(t) {
  switch (t) {
    case "narrow":
      return [...vi];
    case "short":
      return [...bi];
    case "long":
      return [...wi];
    default:
      return null;
  }
}
function Mi(t) {
  return Zn[t.hour < 12 ? 0 : 1];
}
function Di(t, e) {
  return Bn(e)[t.weekday - 1];
}
function ki(t, e) {
  return Hn(e)[t.month - 1];
}
function xi(t, e) {
  return Un(e)[t.year < 0 ? 0 : 1];
}
function Si(t, e, n = "always", r = !1) {
  const s = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, i = ["hours", "minutes", "seconds"].indexOf(t) === -1;
  if (n === "auto" && i) {
    const h = t === "days";
    switch (e) {
      case 1:
        return h ? "tomorrow" : `next ${s[t][0]}`;
      case -1:
        return h ? "yesterday" : `last ${s[t][0]}`;
      case 0:
        return h ? "today" : `this ${s[t][0]}`;
    }
  }
  const a = Object.is(e, -0) || e < 0, o = Math.abs(e), u = o === 1, l = s[t], c = r ? u ? l[1] : l[2] || l[1] : u ? s[t][0] : t;
  return a ? `${o} ${c} ago` : `in ${o} ${c}`;
}
function Ti(t) {
  const e = Rn(t, [
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hour12"
  ]), n = V(e), r = "EEEE, LLLL d, yyyy, h:mm a";
  switch (n) {
    case V(kt):
      return "M/d/yyyy";
    case V(dr):
      return "LLL d, yyyy";
    case V(In):
      return "EEE, LLL d, yyyy";
    case V(fr):
      return "LLLL d, yyyy";
    case V(hr):
      return "EEEE, LLLL d, yyyy";
    case V(mr):
      return "h:mm a";
    case V(yr):
      return "h:mm:ss a";
    case V(gr):
      return "h:mm a";
    case V(pr):
      return "h:mm a";
    case V(wr):
      return "HH:mm";
    case V(br):
      return "HH:mm:ss";
    case V(vr):
      return "HH:mm";
    case V(Mr):
      return "HH:mm";
    case V(Dr):
      return "M/d/yyyy, h:mm a";
    case V(xr):
      return "LLL d, yyyy, h:mm a";
    case V(Tr):
      return "LLLL d, yyyy, h:mm a";
    case V(Cr):
      return r;
    case V(kr):
      return "M/d/yyyy, h:mm:ss a";
    case V(Sr):
      return "LLL d, yyyy, h:mm:ss a";
    case V(Ln):
      return "EEE, d LLL yyyy, h:mm a";
    case V(Or):
      return "LLLL d, yyyy, h:mm:ss a";
    case V(Er):
      return "EEEE, LLLL d, yyyy, h:mm:ss a";
    default:
      return r;
  }
}
function Gr(t, e) {
  let n = "";
  for (const r of t)
    r.literal ? n += r.val : n += e(r.val);
  return n;
}
const Oi = {
  D: kt,
  DD: dr,
  DDD: fr,
  DDDD: hr,
  t: mr,
  tt: yr,
  ttt: gr,
  tttt: pr,
  T: wr,
  TT: br,
  TTT: vr,
  TTTT: Mr,
  f: Dr,
  ff: xr,
  fff: Tr,
  ffff: Cr,
  F: kr,
  FF: Sr,
  FFF: Or,
  FFFF: Er
};
class Q {
  static create(e, n = {}) {
    return new Q(e, n);
  }
  static parseFormat(e) {
    let n = null, r = "", s = !1;
    const i = [];
    for (let a = 0; a < e.length; a++) {
      const o = e.charAt(a);
      o === "'" ? (r.length > 0 && i.push({ literal: s, val: r }), n = null, r = "", s = !s) : s || o === n ? r += o : (r.length > 0 && i.push({ literal: !1, val: r }), r = o, n = o);
    }
    return r.length > 0 && i.push({ literal: s, val: r }), i;
  }
  static macroTokenToFormatOpts(e) {
    return Oi[e];
  }
  constructor(e, n) {
    this.opts = n, this.loc = e, this.systemLoc = null;
  }
  formatWithSystemDefault(e, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(e, Object.assign({}, this.opts, n)).format();
  }
  formatDateTime(e, n = {}) {
    return this.loc.dtFormatter(e, Object.assign({}, this.opts, n)).format();
  }
  formatDateTimeParts(e, n = {}) {
    return this.loc.dtFormatter(e, Object.assign({}, this.opts, n)).formatToParts();
  }
  resolvedOptions(e, n = {}) {
    return this.loc.dtFormatter(e, Object.assign({}, this.opts, n)).resolvedOptions();
  }
  num(e, n = 0) {
    if (this.opts.forceSimple)
      return Ye(e, n);
    const r = Object.assign({}, this.opts);
    return n > 0 && (r.padTo = n), this.loc.numberFormatter(r).format(e);
  }
  formatDateTimeFromString(e, n) {
    const r = this.loc.listingMode() === "en", s = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory" && ut(), i = (m, p) => this.loc.extract(e, m, p), a = (m) => e.isOffsetFixed && e.offset === 0 && m.allowZ ? "Z" : e.isValid ? e.zone.formatOffset(e.ts, m.format) : "", o = () => r ? Mi(e) : i({ hour: "numeric", hour12: !0 }, "dayperiod"), u = (m, p) => r ? ki(e, m) : i(p ? { month: m } : { month: m, day: "numeric" }, "month"), l = (m, p) => r ? Di(e, m) : i(
      p ? { weekday: m } : { weekday: m, month: "long", day: "numeric" },
      "weekday"
    ), c = (m) => {
      const p = Q.macroTokenToFormatOpts(m);
      return p ? this.formatWithSystemDefault(e, p) : m;
    }, h = (m) => r ? xi(e, m) : i({ era: m }, "era"), d = (m) => {
      switch (m) {
        case "S":
          return this.num(e.millisecond);
        case "u":
        case "SSS":
          return this.num(e.millisecond, 3);
        case "s":
          return this.num(e.second);
        case "ss":
          return this.num(e.second, 2);
        case "m":
          return this.num(e.minute);
        case "mm":
          return this.num(e.minute, 2);
        case "h":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12);
        case "hh":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12, 2);
        case "H":
          return this.num(e.hour);
        case "HH":
          return this.num(e.hour, 2);
        case "Z":
          return a({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return a({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return a({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return e.zone.offsetName(e.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return e.zone.offsetName(e.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return e.zoneName;
        case "a":
          return o();
        case "d":
          return s ? i({ day: "numeric" }, "day") : this.num(e.day);
        case "dd":
          return s ? i({ day: "2-digit" }, "day") : this.num(e.day, 2);
        case "c":
          return this.num(e.weekday);
        case "ccc":
          return l("short", !0);
        case "cccc":
          return l("long", !0);
        case "ccccc":
          return l("narrow", !0);
        case "E":
          return this.num(e.weekday);
        case "EEE":
          return l("short", !1);
        case "EEEE":
          return l("long", !1);
        case "EEEEE":
          return l("narrow", !1);
        case "L":
          return s ? i({ month: "numeric", day: "numeric" }, "month") : this.num(e.month);
        case "LL":
          return s ? i({ month: "2-digit", day: "numeric" }, "month") : this.num(e.month, 2);
        case "LLL":
          return u("short", !0);
        case "LLLL":
          return u("long", !0);
        case "LLLLL":
          return u("narrow", !0);
        case "M":
          return s ? i({ month: "numeric" }, "month") : this.num(e.month);
        case "MM":
          return s ? i({ month: "2-digit" }, "month") : this.num(e.month, 2);
        case "MMM":
          return u("short", !1);
        case "MMMM":
          return u("long", !1);
        case "MMMMM":
          return u("narrow", !1);
        case "y":
          return s ? i({ year: "numeric" }, "year") : this.num(e.year);
        case "yy":
          return s ? i({ year: "2-digit" }, "year") : this.num(e.year.toString().slice(-2), 2);
        case "yyyy":
          return s ? i({ year: "numeric" }, "year") : this.num(e.year, 4);
        case "yyyyyy":
          return s ? i({ year: "numeric" }, "year") : this.num(e.year, 6);
        case "G":
          return h("short");
        case "GG":
          return h("long");
        case "GGGGG":
          return h("narrow");
        case "kk":
          return this.num(e.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(e.weekYear, 4);
        case "W":
          return this.num(e.weekNumber);
        case "WW":
          return this.num(e.weekNumber, 2);
        case "o":
          return this.num(e.ordinal);
        case "ooo":
          return this.num(e.ordinal, 3);
        case "q":
          return this.num(e.quarter);
        case "qq":
          return this.num(e.quarter, 2);
        case "X":
          return this.num(Math.floor(e.ts / 1e3));
        case "x":
          return this.num(e.ts);
        default:
          return c(m);
      }
    };
    return Gr(Q.parseFormat(n), d);
  }
  formatDurationFromString(e, n) {
    const r = (u) => {
      switch (u[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, s = (u) => (l) => {
      const c = r(l);
      return c ? this.num(u.get(c), l.length) : l;
    }, i = Q.parseFormat(n), a = i.reduce(
      (u, { literal: l, val: c }) => l ? u : u.concat(c),
      []
    ), o = e.shiftTo(...a.map(r).filter((u) => u));
    return Gr(i, s(o));
  }
}
class he {
  constructor(e, n) {
    this.reason = e, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
class ct {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ke();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ke();
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get universal() {
    throw new ke();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, n) {
    throw new ke();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    throw new ke();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    throw new ke();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    throw new ke();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ke();
  }
}
let Yt = null;
class Ir extends ct {
  /**
   * Get a singleton instance of the local zone
   * @return {LocalZone}
   */
  static get instance() {
    return Yt === null && (Yt = new Ir()), Yt;
  }
  /** @override **/
  get type() {
    return "local";
  }
  /** @override **/
  get name() {
    return ye() ? new Intl.DateTimeFormat().resolvedOptions().timeZone : "local";
  }
  /** @override **/
  get universal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: n, locale: r }) {
    return Vn(e, n, r);
  }
  /** @override **/
  formatOffset(e, n) {
    return Ot(this.offset(e), n);
  }
  /** @override **/
  offset(e) {
    return -new Date(e).getTimezoneOffset();
  }
  /** @override **/
  equals(e) {
    return e.type === "local";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
const Ci = RegExp(`^${$n.source}$`);
let vt = {};
function Ei(t) {
  return vt[t] || (vt[t] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), vt[t];
}
const Ni = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Fi(t, e) {
  const n = t.format(e).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n), [, s, i, a, o, u, l] = r;
  return [a, s, i, o, u, l];
}
function Ai(t, e) {
  const n = t.formatToParts(e), r = [];
  for (let s = 0; s < n.length; s++) {
    const { type: i, value: a } = n[s], o = Ni[i];
    C(o) || (r[o] = parseInt(a, 10));
  }
  return r;
}
let ft = {};
class ue extends ct {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(e) {
    return ft[e] || (ft[e] = new ue(e)), ft[e];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ft = {}, vt = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Fantasia/Castle") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidSpecifier(e) {
    return !!(e && e.match(Ci));
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(e) {
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: e }).format(), !0;
    } catch {
      return !1;
    }
  }
  // Etc/GMT+8 -> -480
  /** @ignore */
  static parseGMTOffset(e) {
    if (e) {
      const n = e.match(/^Etc\/GMT(0|[+-]\d{1,2})$/i);
      if (n)
        return -60 * parseInt(n[1]);
    }
    return null;
  }
  constructor(e) {
    super(), this.zoneName = e, this.valid = ue.isValidZone(e);
  }
  /** @override **/
  get type() {
    return "iana";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get universal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: n, locale: r }) {
    return Vn(e, n, r, this.name);
  }
  /** @override **/
  formatOffset(e, n) {
    return Ot(this.offset(e), n);
  }
  /** @override **/
  offset(e) {
    const n = new Date(e);
    if (isNaN(n)) return NaN;
    const r = Ei(this.name), [s, i, a, o, u, l] = r.formatToParts ? Ai(r, n) : Fi(r, n), h = Ar({
      year: s,
      month: i,
      day: a,
      hour: o === 24 ? 0 : o,
      minute: u,
      second: l,
      millisecond: 0
    });
    let d = +n;
    const m = d % 1e3;
    return d -= m >= 0 ? m : 1e3 + m, (h - d) / (60 * 1e3);
  }
  /** @override **/
  equals(e) {
    return e.type === "iana" && e.name === this.name;
  }
  /** @override **/
  get isValid() {
    return this.valid;
  }
}
let zt = null;
class q extends ct {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return zt === null && (zt = new q(0)), zt;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(e) {
    return e === 0 ? q.utcInstance : new q(e);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(e) {
    if (e) {
      const n = e.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new q(Pt(n[1], n[2]));
    }
    return null;
  }
  constructor(e) {
    super(), this.fixed = e;
  }
  /** @override **/
  get type() {
    return "fixed";
  }
  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Ot(this.fixed, "narrow")}`;
  }
  /** @override **/
  offsetName() {
    return this.name;
  }
  /** @override **/
  formatOffset(e, n) {
    return Ot(this.fixed, n);
  }
  /** @override **/
  get universal() {
    return !0;
  }
  /** @override **/
  offset() {
    return this.fixed;
  }
  /** @override **/
  equals(e) {
    return e.type === "fixed" && e.fixed === this.fixed;
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
class Jr extends ct {
  constructor(e) {
    super(), this.zoneName = e;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get universal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function Ne(t, e) {
  let n;
  if (C(t) || t === null)
    return e;
  if (t instanceof ct)
    return t;
  if (di(t)) {
    const r = t.toLowerCase();
    return r === "local" ? e : r === "utc" || r === "gmt" ? q.utcInstance : (n = ue.parseGMTOffset(t)) != null ? q.instance(n) : ue.isValidSpecifier(r) ? ue.create(t) : q.parseSpecifier(r) || new Jr(t);
  } else return Ae(t) ? q.instance(t) : typeof t == "object" && t.offset && typeof t.offset == "number" ? t : new Jr(t);
}
let Kr = () => Date.now(), Bt = null, Qr = null, Xr = null, en = null, tn = !1;
class j {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return Kr;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(e) {
    Kr = e;
  }
  /**
   * Get the default time zone to create DateTimes in.
   * @type {string}
   */
  static get defaultZoneName() {
    return j.defaultZone.name;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * @type {string}
   */
  static set defaultZoneName(e) {
    e ? Bt = Ne(e) : Bt = null;
  }
  /**
   * Get the default time zone object to create DateTimes in. Does not affect existing instances.
   * @type {Zone}
   */
  static get defaultZone() {
    return Bt || Ir.instance;
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return Qr;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(e) {
    Qr = e;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return Xr;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(e) {
    Xr = e;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return en;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(e) {
    en = e;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return tn;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(e) {
    tn = e;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    W.resetCache(), ue.resetCache();
  }
}
let Xt = {};
function er(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = Xt[n];
  return r || (r = new Intl.DateTimeFormat(t, e), Xt[n] = r), r;
}
let tr = {};
function Ii(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = tr[n];
  return r || (r = new Intl.NumberFormat(t, e), tr[n] = r), r;
}
let rr = {};
function Li(t, e = {}) {
  const { base: n, ...r } = e, s = JSON.stringify([t, r]);
  let i = rr[s];
  return i || (i = new Intl.RelativeTimeFormat(t, e), rr[s] = i), i;
}
let Ee = null;
function Pi() {
  if (Ee)
    return Ee;
  if (ye()) {
    const t = new Intl.DateTimeFormat().resolvedOptions().locale;
    return Ee = !t || t === "und" ? "en-US" : t, Ee;
  } else
    return Ee = "en-US", Ee;
}
function Ri(t) {
  const e = t.indexOf("-u-");
  if (e === -1)
    return [t];
  {
    let n;
    const r = t.substring(0, e);
    try {
      n = er(t).resolvedOptions();
    } catch {
      n = er(r).resolvedOptions();
    }
    const { numberingSystem: s, calendar: i } = n;
    return [r, s, i];
  }
}
function Vi(t, e, n) {
  return ye() ? ((n || e) && (t += "-u", n && (t += `-ca-${n}`), e && (t += `-nu-${e}`)), t) : [];
}
function ji(t) {
  const e = [];
  for (let n = 1; n <= 12; n++) {
    const r = b.utc(2016, n, 1);
    e.push(t(r));
  }
  return e;
}
function $i(t) {
  const e = [];
  for (let n = 1; n <= 7; n++) {
    const r = b.utc(2016, 11, 13 + n);
    e.push(t(r));
  }
  return e;
}
function ht(t, e, n, r, s) {
  const i = t.listingMode(n);
  return i === "error" ? null : i === "en" ? r(e) : s(e);
}
function Wi(t) {
  return t.numberingSystem && t.numberingSystem !== "latn" ? !1 : t.numberingSystem === "latn" || !t.locale || t.locale.startsWith("en") || ye() && new Intl.DateTimeFormat(t.intl).resolvedOptions().numberingSystem === "latn";
}
class Hi {
  constructor(e, n, r) {
    if (this.padTo = r.padTo || 0, this.floor = r.floor || !1, !n && ye()) {
      const s = { useGrouping: !1 };
      r.padTo > 0 && (s.minimumIntegerDigits = r.padTo), this.inf = Ii(e, s);
    }
  }
  format(e) {
    if (this.inf) {
      const n = this.floor ? Math.floor(e) : e;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(e) : Fr(e, 3);
      return Ye(n, this.padTo);
    }
  }
}
class Yi {
  constructor(e, n, r) {
    this.opts = r, this.hasIntl = ye();
    let s;
    if (e.zone.universal && this.hasIntl) {
      const i = -1 * (e.offset / 60), a = i >= 0 ? `Etc/GMT+${i}` : `Etc/GMT${i}`, o = ue.isValidZone(a);
      e.offset !== 0 && o ? (s = a, this.dt = e) : (s = "UTC", r.timeZoneName ? this.dt = e : this.dt = e.offset === 0 ? e : b.fromMillis(e.ts + e.offset * 60 * 1e3));
    } else e.zone.type === "local" ? this.dt = e : (this.dt = e, s = e.zone.name);
    if (this.hasIntl) {
      const i = Object.assign({}, this.opts);
      s && (i.timeZone = s), this.dtf = er(n, i);
    }
  }
  format() {
    if (this.hasIntl)
      return this.dtf.format(this.dt.toJSDate());
    {
      const e = Ti(this.opts), n = W.create("en-US");
      return Q.create(n).formatDateTimeFromString(this.dt, e);
    }
  }
  formatToParts() {
    return this.hasIntl && ut() ? this.dtf.formatToParts(this.dt.toJSDate()) : [];
  }
  resolvedOptions() {
    return this.hasIntl ? this.dtf.resolvedOptions() : {
      locale: "en-US",
      numberingSystem: "latn",
      outputCalendar: "gregory"
    };
  }
}
class zi {
  constructor(e, n, r) {
    this.opts = Object.assign({ style: "long" }, r), !n && Pn() && (this.rtf = Li(e, r));
  }
  format(e, n) {
    return this.rtf ? this.rtf.format(e, n) : Si(n, e, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(e, n) {
    return this.rtf ? this.rtf.formatToParts(e, n) : [];
  }
}
class W {
  static fromOpts(e) {
    return W.create(e.locale, e.numberingSystem, e.outputCalendar, e.defaultToEN);
  }
  static create(e, n, r, s = !1) {
    const i = e || j.defaultLocale, a = i || (s ? "en-US" : Pi()), o = n || j.defaultNumberingSystem, u = r || j.defaultOutputCalendar;
    return new W(a, o, u, i);
  }
  static resetCache() {
    Ee = null, Xt = {}, tr = {}, rr = {};
  }
  static fromObject({ locale: e, numberingSystem: n, outputCalendar: r } = {}) {
    return W.create(e, n, r);
  }
  constructor(e, n, r, s) {
    const [i, a, o] = Ri(e);
    this.locale = i, this.numberingSystem = n || a || null, this.outputCalendar = r || o || null, this.intl = Vi(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = s, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = Wi(this)), this.fastNumbersCached;
  }
  listingMode(e = !0) {
    const n = ye(), r = n && ut(), s = this.isEnglish(), i = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return !r && !(s && i) && !e ? "error" : !r || s && i ? "en" : "intl";
  }
  clone(e) {
    return !e || Object.getOwnPropertyNames(e).length === 0 ? this : W.create(
      e.locale || this.specifiedLocale,
      e.numberingSystem || this.numberingSystem,
      e.outputCalendar || this.outputCalendar,
      e.defaultToEN || !1
    );
  }
  redefaultToEN(e = {}) {
    return this.clone(Object.assign({}, e, { defaultToEN: !0 }));
  }
  redefaultToSystem(e = {}) {
    return this.clone(Object.assign({}, e, { defaultToEN: !1 }));
  }
  months(e, n = !1, r = !0) {
    return ht(this, e, r, Hn, () => {
      const s = n ? { month: e, day: "numeric" } : { month: e }, i = n ? "format" : "standalone";
      return this.monthsCache[i][e] || (this.monthsCache[i][e] = ji((a) => this.extract(a, s, "month"))), this.monthsCache[i][e];
    });
  }
  weekdays(e, n = !1, r = !0) {
    return ht(this, e, r, Bn, () => {
      const s = n ? { weekday: e, year: "numeric", month: "long", day: "numeric" } : { weekday: e }, i = n ? "format" : "standalone";
      return this.weekdaysCache[i][e] || (this.weekdaysCache[i][e] = $i(
        (a) => this.extract(a, s, "weekday")
      )), this.weekdaysCache[i][e];
    });
  }
  meridiems(e = !0) {
    return ht(
      this,
      void 0,
      e,
      () => Zn,
      () => {
        if (!this.meridiemCache) {
          const n = { hour: "numeric", hour12: !0 };
          this.meridiemCache = [b.utc(2016, 11, 13, 9), b.utc(2016, 11, 13, 19)].map(
            (r) => this.extract(r, n, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(e, n = !0) {
    return ht(this, e, n, Un, () => {
      const r = { era: e };
      return this.eraCache[e] || (this.eraCache[e] = [b.utc(-40, 1, 1), b.utc(2017, 1, 1)].map(
        (s) => this.extract(s, r, "era")
      )), this.eraCache[e];
    });
  }
  extract(e, n, r) {
    const s = this.dtFormatter(e, n), i = s.formatToParts(), a = i.find((o) => o.type.toLowerCase() === r);
    return a ? a.value : null;
  }
  numberFormatter(e = {}) {
    return new Hi(this.intl, e.forceSimple || this.fastNumbers, e);
  }
  dtFormatter(e, n = {}) {
    return new Yi(e, this.intl, n);
  }
  relFormatter(e = {}) {
    return new zi(this.intl, this.isEnglish(), e);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || ye() && new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  equals(e) {
    return this.locale === e.locale && this.numberingSystem === e.numberingSystem && this.outputCalendar === e.outputCalendar;
  }
}
function _e(...t) {
  const e = t.reduce((n, r) => n + r.source, "");
  return RegExp(`^${e}$`);
}
function Pe(...t) {
  return (e) => t.reduce(
    ([n, r, s], i) => {
      const [a, o, u] = i(e, s);
      return [Object.assign(n, a), r || o, u];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function qe(t, ...e) {
  if (t == null)
    return [null, null];
  for (const [n, r] of e) {
    const s = n.exec(t);
    if (s)
      return r(s);
  }
  return [null, null];
}
function _n(...t) {
  return (e, n) => {
    const r = {};
    let s;
    for (s = 0; s < t.length; s++)
      r[t[s]] = K(e[n + s]);
    return [r, null, n + s];
  };
}
const qn = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, Lr = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, Gn = RegExp(`${Lr.source}${qn.source}?`), Pr = RegExp(`(?:T${Gn.source})?`), Bi = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, Zi = /(\d{4})-?W(\d\d)(?:-?(\d))?/, Ui = /(\d{4})-?(\d{3})/, _i = _n("weekYear", "weekNumber", "weekDay"), qi = _n("year", "ordinal"), Gi = /(\d{4})-(\d\d)-(\d\d)/, Jn = RegExp(
  `${Lr.source} ?(?:${qn.source}|(${$n.source}))?`
), Ji = RegExp(`(?: ${Jn.source})?`);
function Ze(t, e, n) {
  const r = t[e];
  return C(r) ? n : K(r);
}
function Kn(t, e) {
  return [{
    year: Ze(t, e),
    month: Ze(t, e + 1, 1),
    day: Ze(t, e + 2, 1)
  }, null, e + 3];
}
function Re(t, e) {
  return [{
    hours: Ze(t, e, 0),
    minutes: Ze(t, e + 1, 0),
    seconds: Ze(t, e + 2, 0),
    milliseconds: Nr(t[e + 3])
  }, null, e + 4];
}
function Ge(t, e) {
  const n = !t[e] && !t[e + 1], r = Pt(t[e + 1], t[e + 2]), s = n ? null : q.instance(r);
  return [{}, s, e + 3];
}
function Qn(t, e) {
  const n = t[e] ? ue.create(t[e]) : null;
  return [{}, n, e + 1];
}
const Ki = RegExp(`^T?${Lr.source}$`), Qi = /^-?P(?:(?:(-?\d{1,9})Y)?(?:(-?\d{1,9})M)?(?:(-?\d{1,9})W)?(?:(-?\d{1,9})D)?(?:T(?:(-?\d{1,9})H)?(?:(-?\d{1,9})M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,9}))?S)?)?)$/;
function Xi(t) {
  const [
    e,
    n,
    r,
    s,
    i,
    a,
    o,
    u,
    l
  ] = t, c = e[0] === "-", h = u && u[0] === "-", d = (m, p = !1) => m !== void 0 && (p || m && c) ? -m : m;
  return [
    {
      years: d(K(n)),
      months: d(K(r)),
      weeks: d(K(s)),
      days: d(K(i)),
      hours: d(K(a)),
      minutes: d(K(o)),
      seconds: d(K(u), u === "-0"),
      milliseconds: d(Nr(l), h)
    }
  ];
}
const ea = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Rr(t, e, n, r, s, i, a) {
  const o = {
    year: e.length === 2 ? Qt(K(e)) : K(e),
    month: Wn.indexOf(n) + 1,
    day: K(r),
    hour: K(s),
    minute: K(i)
  };
  return a && (o.second = K(a)), t && (o.weekday = t.length > 3 ? Yn.indexOf(t) + 1 : zn.indexOf(t) + 1), o;
}
const ta = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function ra(t) {
  const [
    ,
    e,
    n,
    r,
    s,
    i,
    a,
    o,
    u,
    l,
    c,
    h
  ] = t, d = Rr(e, s, r, n, i, a, o);
  let m;
  return u ? m = ea[u] : l ? m = 0 : m = Pt(c, h), [d, new q(m)];
}
function na(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const sa = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, ia = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, aa = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function rn(t) {
  const [, e, n, r, s, i, a, o] = t;
  return [Rr(e, s, r, n, i, a, o), q.utcInstance];
}
function oa(t) {
  const [, e, n, r, s, i, a, o] = t;
  return [Rr(e, o, n, r, s, i, a), q.utcInstance];
}
const ua = _e(Bi, Pr), la = _e(Zi, Pr), ca = _e(Ui, Pr), da = _e(Gn), fa = Pe(
  Kn,
  Re,
  Ge
), ha = Pe(
  _i,
  Re,
  Ge
), ma = Pe(
  qi,
  Re,
  Ge
), ya = Pe(Re, Ge);
function ga(t) {
  return qe(
    t,
    [ua, fa],
    [la, ha],
    [ca, ma],
    [da, ya]
  );
}
function pa(t) {
  return qe(na(t), [ta, ra]);
}
function wa(t) {
  return qe(
    t,
    [sa, rn],
    [ia, rn],
    [aa, oa]
  );
}
function ba(t) {
  return qe(t, [Qi, Xi]);
}
const va = Pe(Re);
function Ma(t) {
  return qe(t, [Ki, va]);
}
const Da = _e(Gi, Ji), ka = _e(Jn), xa = Pe(
  Kn,
  Re,
  Ge,
  Qn
), Sa = Pe(
  Re,
  Ge,
  Qn
);
function Ta(t) {
  return qe(
    t,
    [Da, xa],
    [ka, Sa]
  );
}
const Oa = "Invalid Duration", Xn = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, Ca = Object.assign(
  {
    years: {
      quarters: 4,
      months: 12,
      weeks: 52,
      days: 365,
      hours: 365 * 24,
      minutes: 365 * 24 * 60,
      seconds: 365 * 24 * 60 * 60,
      milliseconds: 365 * 24 * 60 * 60 * 1e3
    },
    quarters: {
      months: 3,
      weeks: 13,
      days: 91,
      hours: 91 * 24,
      minutes: 91 * 24 * 60,
      seconds: 91 * 24 * 60 * 60,
      milliseconds: 91 * 24 * 60 * 60 * 1e3
    },
    months: {
      weeks: 4,
      days: 30,
      hours: 30 * 24,
      minutes: 30 * 24 * 60,
      seconds: 30 * 24 * 60 * 60,
      milliseconds: 30 * 24 * 60 * 60 * 1e3
    }
  },
  Xn
), se = 146097 / 400, $e = 146097 / 4800, Ea = Object.assign(
  {
    years: {
      quarters: 4,
      months: 12,
      weeks: se / 7,
      days: se,
      hours: se * 24,
      minutes: se * 24 * 60,
      seconds: se * 24 * 60 * 60,
      milliseconds: se * 24 * 60 * 60 * 1e3
    },
    quarters: {
      months: 3,
      weeks: se / 28,
      days: se / 4,
      hours: se * 24 / 4,
      minutes: se * 24 * 60 / 4,
      seconds: se * 24 * 60 * 60 / 4,
      milliseconds: se * 24 * 60 * 60 * 1e3 / 4
    },
    months: {
      weeks: $e / 7,
      days: $e,
      hours: $e * 24,
      minutes: $e * 24 * 60,
      seconds: $e * 24 * 60 * 60,
      milliseconds: $e * 24 * 60 * 60 * 1e3
    }
  },
  Xn
), We = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], Na = We.slice(0).reverse();
function Ce(t, e, n = !1) {
  const r = {
    values: n ? e.values : Object.assign({}, t.values, e.values || {}),
    loc: t.loc.clone(e.loc),
    conversionAccuracy: e.conversionAccuracy || t.conversionAccuracy
  };
  return new I(r);
}
function Fa(t) {
  return t < 0 ? Math.floor(t) : Math.ceil(t);
}
function es(t, e, n, r, s) {
  const i = t[s][n], a = e[n] / i, o = Math.sign(a) === Math.sign(r[s]), u = !o && r[s] !== 0 && Math.abs(a) <= 1 ? Fa(a) : Math.trunc(a);
  r[s] += u, e[n] -= u * i;
}
function Aa(t, e) {
  Na.reduce((n, r) => C(e[r]) ? n : (n && es(t, e, n, e, r), r), null);
}
class I {
  /**
   * @private
   */
  constructor(e) {
    const n = e.conversionAccuracy === "longterm" || !1;
    this.values = e.values, this.loc = e.loc || W.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = e.invalid || null, this.matrix = n ? Ea : Ca, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(e, n) {
    return I.fromObject(Object.assign({ milliseconds: e }, n));
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {string} [obj.locale='en-US'] - the locale to use
   * @param {string} obj.numberingSystem - the numbering system to use
   * @param {string} [obj.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromObject(e) {
    if (e == null || typeof e != "object")
      throw new ie(
        `Duration.fromObject: argument expected to be an object, got ${e === null ? "null" : typeof e}`
      );
    return new I({
      values: Tt(e, I.normalizeUnit, [
        "locale",
        "numberingSystem",
        "conversionAccuracy",
        "zone"
        // a bit of debt; it's super inconvenient internally not to be able to blindly pass this
      ]),
      loc: W.fromObject(e),
      conversionAccuracy: e.conversionAccuracy
    });
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(e, n) {
    const [r] = ba(e);
    if (r) {
      const s = Object.assign(r, n);
      return I.fromObject(s);
    } else
      return I.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(e, n) {
    const [r] = Ma(e);
    if (r) {
      const s = Object.assign(r, n);
      return I.fromObject(s);
    } else
      return I.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new ie("need to specify a reason the Duration is invalid");
    const r = e instanceof he ? e : new he(e, n);
    if (j.throwOnInvalid)
      throw new ci(r);
    return new I({ invalid: r });
  }
  /**
   * @private
   */
  static normalizeUnit(e) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[e && e.toLowerCase()];
    if (!n) throw new An(e);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(e) {
    return e && e.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * The duration will be converted to the set of units in the format string using {@link Duration.shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(e, n = {}) {
    const r = Object.assign({}, n, {
      floor: n.round !== !1 && n.floor !== !1
    });
    return this.isValid ? Q.create(this.loc, r).formatDurationFromString(this, e) : Oa;
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject(e = {}) {
    if (!this.isValid) return {};
    const n = Object.assign({}, this.values);
    return e.includeConfig && (n.conversionAccuracy = this.conversionAccuracy, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let e = "P";
    return this.years !== 0 && (e += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (e += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (e += this.weeks + "W"), this.days !== 0 && (e += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (e += "T"), this.hours !== 0 && (e += this.hours + "H"), this.minutes !== 0 && (e += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (e += Fr(this.seconds + this.milliseconds / 1e3, 3) + "S"), e === "P" && (e += "T0S"), e;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(e = {}) {
    if (!this.isValid) return null;
    const n = this.toMillis();
    if (n < 0 || n >= 864e5) return null;
    e = Object.assign(
      {
        suppressMilliseconds: !1,
        suppressSeconds: !1,
        includePrefix: !1,
        format: "extended"
      },
      e
    );
    const r = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
    let s = e.format === "basic" ? "hhmm" : "hh:mm";
    (!e.suppressSeconds || r.seconds !== 0 || r.milliseconds !== 0) && (s += e.format === "basic" ? "ss" : ":ss", (!e.suppressMilliseconds || r.milliseconds !== 0) && (s += ".SSS"));
    let i = r.toFormat(s);
    return e.includePrefix && (i = "T" + i), i;
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.as("milliseconds");
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = Fe(e), r = {};
    for (const s of We)
      (Ue(n.values, s) || Ue(this.values, s)) && (r[s] = n.get(s) + this.get(s));
    return Ce(this, { values: r }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = Fe(e);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnit(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnit((x, u) => u === "hour" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(e) {
    if (!this.isValid) return this;
    const n = {};
    for (const r of Object.keys(this.values))
      n[r] = jn(e(this.values[r], r));
    return Ce(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(e) {
    return this[I.normalizeUnit(e)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = Object.assign(this.values, Tt(e, I.normalizeUnit, []));
    return Ce(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: e, numberingSystem: n, conversionAccuracy: r } = {}) {
    const s = this.loc.clone({ locale: e, numberingSystem: n }), i = { loc: s };
    return r && (i.conversionAccuracy = r), Ce(this, i);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(e) {
    return this.isValid ? this.shiftTo(e).get(e) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const e = this.toObject();
    return Aa(this.matrix, e), Ce(this, { values: e }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...e) {
    if (!this.isValid) return this;
    if (e.length === 0)
      return this;
    e = e.map((a) => I.normalizeUnit(a));
    const n = {}, r = {}, s = this.toObject();
    let i;
    for (const a of We)
      if (e.indexOf(a) >= 0) {
        i = a;
        let o = 0;
        for (const l in r)
          o += this.matrix[l][a] * r[l], r[l] = 0;
        Ae(s[a]) && (o += s[a]);
        const u = Math.trunc(o);
        n[a] = u, r[a] = o - u;
        for (const l in s)
          We.indexOf(l) > We.indexOf(a) && es(this.matrix, s, l, n, a);
      } else Ae(s[a]) && (r[a] = s[a]);
    for (const a in r)
      r[a] !== 0 && (n[i] += a === i ? r[a] : r[a] / this.matrix[i][a]);
    return Ce(this, { values: n }, !0).normalize();
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const e = {};
    for (const n of Object.keys(this.values))
      e[n] = -this.values[n];
    return Ce(this, { values: e }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(e) {
    if (!this.isValid || !e.isValid || !this.loc.equals(e.loc))
      return !1;
    function n(r, s) {
      return r === void 0 || r === 0 ? s === void 0 || s === 0 : r === s;
    }
    for (const r of We)
      if (!n(this.values[r], e.values[r]))
        return !1;
    return !0;
  }
}
function Fe(t) {
  if (Ae(t))
    return I.fromMillis(t);
  if (I.isDuration(t))
    return t;
  if (typeof t == "object")
    return I.fromObject(t);
  throw new ie(
    `Unknown duration argument ${t} of type ${typeof t}`
  );
}
const Qe = "Invalid Interval";
function Ia(t, e) {
  return !t || !t.isValid ? z.invalid("missing or invalid start") : !e || !e.isValid ? z.invalid("missing or invalid end") : e < t ? z.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${t.toISO()} and end=${e.toISO()}`
  ) : null;
}
class z {
  /**
   * @private
   */
  constructor(e) {
    this.s = e.start, this.e = e.end, this.invalid = e.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new ie("need to specify a reason the Interval is invalid");
    const r = e instanceof he ? e : new he(e, n);
    if (j.throwOnInvalid)
      throw new li(r);
    return new z({ invalid: r });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(e, n) {
    const r = tt(e), s = tt(n), i = Ia(r, s);
    return i ?? new z({
      start: r,
      end: s
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(e, n) {
    const r = Fe(n), s = tt(e);
    return z.fromDateTimes(s, s.plus(r));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(e, n) {
    const r = Fe(n), s = tt(e);
    return z.fromDateTimes(s.minus(r), s);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime.fromISO} and optionally {@link Duration.fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(e, n) {
    const [r, s] = (e || "").split("/", 2);
    if (r && s) {
      let i, a;
      try {
        i = b.fromISO(r, n), a = i.isValid;
      } catch {
        a = !1;
      }
      let o, u;
      try {
        o = b.fromISO(s, n), u = o.isValid;
      } catch {
        u = !1;
      }
      if (a && u)
        return z.fromDateTimes(i, o);
      if (a) {
        const l = I.fromISO(s, n);
        if (l.isValid)
          return z.after(i, l);
      } else if (u) {
        const l = I.fromISO(r, n);
        if (l.isValid)
          return z.before(o, l);
      }
    }
    return z.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(e) {
    return e && e.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(e = "milliseconds") {
    return this.isValid ? this.toDuration(e).get(e) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */
  count(e = "milliseconds") {
    if (!this.isValid) return NaN;
    const n = this.start.startOf(e), r = this.end.startOf(e);
    return Math.floor(r.diff(n, e).get(e)) + 1;
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(e) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, e) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(e) {
    return this.isValid ? this.s > e : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(e) {
    return this.isValid ? this.e <= e : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(e) {
    return this.isValid ? this.s <= e && this.e > e : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: e, end: n } = {}) {
    return this.isValid ? z.fromDateTimes(e || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...[DateTime]} dateTimes - the unit of time to count.
   * @return {[Interval]}
   */
  splitAt(...e) {
    if (!this.isValid) return [];
    const n = e.map(tt).filter((a) => this.contains(a)).sort(), r = [];
    let { s } = this, i = 0;
    for (; s < this.e; ) {
      const a = n[i] || this.e, o = +a > +this.e ? this.e : a;
      r.push(z.fromDateTimes(s, o)), s = o, i += 1;
    }
    return r;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {[Interval]}
   */
  splitBy(e) {
    const n = Fe(e);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: r } = this, s = 1, i;
    const a = [];
    for (; r < this.e; ) {
      const o = this.start.plus(n.mapUnits((u) => u * s));
      i = +o > +this.e ? this.e : o, a.push(z.fromDateTimes(r, i)), r = i, s += 1;
    }
    return a;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {[Interval]}
   */
  divideEqually(e) {
    return this.isValid ? this.splitBy(this.length() / e).slice(0, e) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(e) {
    return this.e > e.s && this.s < e.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(e) {
    return this.isValid ? +this.e == +e.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(e) {
    return this.isValid ? +e.e == +this.s : !1;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(e) {
    return this.isValid ? this.s <= e.s && this.e >= e.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(e) {
    return !this.isValid || !e.isValid ? !1 : this.s.equals(e.s) && this.e.equals(e.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(e) {
    if (!this.isValid) return this;
    const n = this.s > e.s ? this.s : e.s, r = this.e < e.e ? this.e : e.e;
    return n >= r ? null : z.fromDateTimes(n, r);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(e) {
    if (!this.isValid) return this;
    const n = this.s < e.s ? this.s : e.s, r = this.e > e.e ? this.e : e.e;
    return z.fromDateTimes(n, r);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {[Interval]} intervals
   * @return {[Interval]}
   */
  static merge(e) {
    const [n, r] = e.sort((s, i) => s.s - i.s).reduce(
      ([s, i], a) => i ? i.overlaps(a) || i.abutsStart(a) ? [s, i.union(a)] : [s.concat([i]), a] : [s, a],
      [[], null]
    );
    return r && n.push(r), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {[Interval]} intervals
   * @return {[Interval]}
   */
  static xor(e) {
    let n = null, r = 0;
    const s = [], i = e.map((u) => [{ time: u.s, type: "s" }, { time: u.e, type: "e" }]), a = Array.prototype.concat(...i), o = a.sort((u, l) => u.time - l.time);
    for (const u of o)
      r += u.type === "s" ? 1 : -1, r === 1 ? n = u.time : (n && +n != +u.time && s.push(z.fromDateTimes(n, u.time)), n = null);
    return z.merge(s);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {[Interval]}
   */
  difference(...e) {
    return z.xor([this].concat(e)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : Qe;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime.toISO}
   * @return {string}
   */
  toISO(e) {
    return this.isValid ? `${this.s.toISO(e)}/${this.e.toISO(e)}` : Qe;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : Qe;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime.toISO}
   * @return {string}
   */
  toISOTime(e) {
    return this.isValid ? `${this.s.toISOTime(e)}/${this.e.toISOTime(e)}` : Qe;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format string.
   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime.toFormat} for details.
   * @param {Object} opts - options
   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
   * @return {string}
   */
  toFormat(e, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(e)}${n}${this.e.toFormat(e)}` : Qe;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(e, n) {
    return this.isValid ? this.e.diff(this.s, e, n) : I.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(e) {
    return z.fromDateTimes(e(this.s), e(this.e));
  }
}
class ze {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(e = j.defaultZone) {
    const n = b.now().setZone(e).set({ month: 12 });
    return !e.universal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(e) {
    return ue.isValidSpecifier(e) && ue.isValidZone(e);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone.isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(e) {
    return Ne(e, j.defaultZone);
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {[string]}
   */
  static months(e = "long", { locale: n = null, numberingSystem: r = null, locObj: s = null, outputCalendar: i = "gregory" } = {}) {
    return (s || W.create(n, r, i)).months(e);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {[string]}
   */
  static monthsFormat(e = "long", { locale: n = null, numberingSystem: r = null, locObj: s = null, outputCalendar: i = "gregory" } = {}) {
    return (s || W.create(n, r, i)).months(e, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {[string]}
   */
  static weekdays(e = "long", { locale: n = null, numberingSystem: r = null, locObj: s = null } = {}) {
    return (s || W.create(n, r, null)).weekdays(e);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link weekdays}
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {[string]}
   */
  static weekdaysFormat(e = "long", { locale: n = null, numberingSystem: r = null, locObj: s = null } = {}) {
    return (s || W.create(n, r, null)).weekdays(e, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {[string]}
   */
  static meridiems({ locale: e = null } = {}) {
    return W.create(e).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {[string]}
   */
  static eras(e = "short", { locale: n = null } = {}) {
    return W.create(n, null, "gregory").eras(e);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, timezone support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `zones`: whether this environment supports IANA timezones
   * * `intlTokens`: whether this environment supports internationalized token-based formatting/parsing
   * * `intl`: whether this environment supports general internationalization
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { intl: true, intlTokens: false, zones: true, relative: false }
   * @return {Object}
   */
  static features() {
    let e = !1, n = !1, r = !1, s = !1;
    if (ye()) {
      e = !0, n = ut(), s = Pn();
      try {
        r = new Intl.DateTimeFormat("en", { timeZone: "America/New_York" }).resolvedOptions().timeZone === "America/New_York";
      } catch {
        r = !1;
      }
    }
    return { intl: e, intlTokens: n, zones: r, relative: s };
  }
}
function nn(t, e) {
  const n = (s) => s.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), r = n(e) - n(t);
  return Math.floor(I.fromMillis(r).as("days"));
}
function La(t, e, n) {
  const r = [
    ["years", (o, u) => u.year - o.year],
    ["quarters", (o, u) => u.quarter - o.quarter],
    ["months", (o, u) => u.month - o.month + (u.year - o.year) * 12],
    [
      "weeks",
      (o, u) => {
        const l = nn(o, u);
        return (l - l % 7) / 7;
      }
    ],
    ["days", nn]
  ], s = {};
  let i, a;
  for (const [o, u] of r)
    if (n.indexOf(o) >= 0) {
      i = o;
      let l = u(t, e);
      a = t.plus({ [o]: l }), a > e ? (t = t.plus({ [o]: l - 1 }), l -= 1) : t = a, s[o] = l;
    }
  return [t, s, a, i];
}
function Pa(t, e, n, r) {
  let [s, i, a, o] = La(t, e, n);
  const u = e - s, l = n.filter(
    (h) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(h) >= 0
  );
  l.length === 0 && (a < e && (a = s.plus({ [o]: 1 })), a !== s && (i[o] = (i[o] || 0) + u / (a - s)));
  const c = I.fromObject(Object.assign(i, r));
  return l.length > 0 ? I.fromMillis(u, r).shiftTo(...l).plus(c) : c;
}
const Vr = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, sn = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, Ra = Vr.hanidec.replace(/[\[|\]]/g, "").split("");
function Va(t) {
  let e = parseInt(t, 10);
  if (isNaN(e)) {
    e = "";
    for (let n = 0; n < t.length; n++) {
      const r = t.charCodeAt(n);
      if (t[n].search(Vr.hanidec) !== -1)
        e += Ra.indexOf(t[n]);
      else
        for (const s in sn) {
          const [i, a] = sn[s];
          r >= i && r <= a && (e += r - i);
        }
    }
    return parseInt(e, 10);
  } else
    return e;
}
function ce({ numberingSystem: t }, e = "") {
  return new RegExp(`${Vr[t || "latn"]}${e}`);
}
const ja = "missing Intl.DateTimeFormat.formatToParts support";
function N(t, e = (n) => n) {
  return { regex: t, deser: ([n]) => e(Va(n)) };
}
const $a = " ", ts = `( |${$a})`, rs = new RegExp(ts, "g");
function Wa(t) {
  return t.replace(/\./g, "\\.?").replace(rs, ts);
}
function an(t) {
  return t.replace(/\./g, "").replace(rs, " ").toLowerCase();
}
function de(t, e) {
  return t === null ? null : {
    regex: RegExp(t.map(Wa).join("|")),
    deser: ([n]) => t.findIndex((r) => an(n) === an(r)) + e
  };
}
function on(t, e) {
  return { regex: t, deser: ([, n, r]) => Pt(n, r), groups: e };
}
function un(t) {
  return { regex: t, deser: ([e]) => e };
}
function Ha(t) {
  return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function Ya(t, e) {
  const n = ce(e), r = ce(e, "{2}"), s = ce(e, "{3}"), i = ce(e, "{4}"), a = ce(e, "{6}"), o = ce(e, "{1,2}"), u = ce(e, "{1,3}"), l = ce(e, "{1,6}"), c = ce(e, "{1,9}"), h = ce(e, "{2,4}"), d = ce(e, "{4,6}"), m = (D) => ({ regex: RegExp(Ha(D.val)), deser: ([S]) => S, literal: !0 }), w = ((D) => {
    if (t.literal)
      return m(D);
    switch (D.val) {
      case "G":
        return de(e.eras("short", !1), 0);
      case "GG":
        return de(e.eras("long", !1), 0);
      case "y":
        return N(l);
      case "yy":
        return N(h, Qt);
      case "yyyy":
        return N(i);
      case "yyyyy":
        return N(d);
      case "yyyyyy":
        return N(a);
      case "M":
        return N(o);
      case "MM":
        return N(r);
      case "MMM":
        return de(e.months("short", !0, !1), 1);
      case "MMMM":
        return de(e.months("long", !0, !1), 1);
      case "L":
        return N(o);
      case "LL":
        return N(r);
      case "LLL":
        return de(e.months("short", !1, !1), 1);
      case "LLLL":
        return de(e.months("long", !1, !1), 1);
      case "d":
        return N(o);
      case "dd":
        return N(r);
      case "o":
        return N(u);
      case "ooo":
        return N(s);
      case "HH":
        return N(r);
      case "H":
        return N(o);
      case "hh":
        return N(r);
      case "h":
        return N(o);
      case "mm":
        return N(r);
      case "m":
        return N(o);
      case "q":
        return N(o);
      case "qq":
        return N(r);
      case "s":
        return N(o);
      case "ss":
        return N(r);
      case "S":
        return N(u);
      case "SSS":
        return N(s);
      case "u":
        return un(c);
      case "a":
        return de(e.meridiems(), 0);
      case "kkkk":
        return N(i);
      case "kk":
        return N(h, Qt);
      case "W":
        return N(o);
      case "WW":
        return N(r);
      case "E":
      case "c":
        return N(n);
      case "EEE":
        return de(e.weekdays("short", !1, !1), 1);
      case "EEEE":
        return de(e.weekdays("long", !1, !1), 1);
      case "ccc":
        return de(e.weekdays("short", !0, !1), 1);
      case "cccc":
        return de(e.weekdays("long", !0, !1), 1);
      case "Z":
      case "ZZ":
        return on(new RegExp(`([+-]${o.source})(?::(${r.source}))?`), 2);
      case "ZZZ":
        return on(new RegExp(`([+-]${o.source})(${r.source})?`), 2);
      case "z":
        return un(/[a-z_+-/]{1,256}?/i);
      default:
        return m(D);
    }
  })(t) || {
    invalidReason: ja
  };
  return w.token = t, w;
}
const za = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour: {
    numeric: "h",
    "2-digit": "hh"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  }
};
function Ba(t, e, n) {
  const { type: r, value: s } = t;
  if (r === "literal")
    return {
      literal: !0,
      val: s
    };
  const i = n[r];
  let a = za[r];
  if (typeof a == "object" && (a = a[i]), a)
    return {
      literal: !1,
      val: a
    };
}
function Za(t) {
  return [`^${t.map((n) => n.regex).reduce((n, r) => `${n}(${r.source})`, "")}$`, t];
}
function Ua(t, e, n) {
  const r = t.match(e);
  if (r) {
    const s = {};
    let i = 1;
    for (const a in n)
      if (Ue(n, a)) {
        const o = n[a], u = o.groups ? o.groups + 1 : 1;
        !o.literal && o.token && (s[o.token.val[0]] = o.deser(r.slice(i, i + u))), i += u;
      }
    return [r, s];
  } else
    return [r, {}];
}
function _a(t) {
  const e = (s) => {
    switch (s) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n;
  return C(t.Z) ? C(t.z) ? n = null : n = ue.create(t.z) : n = new q(t.Z), C(t.q) || (t.M = (t.q - 1) * 3 + 1), C(t.h) || (t.h < 12 && t.a === 1 ? t.h += 12 : t.h === 12 && t.a === 0 && (t.h = 0)), t.G === 0 && t.y && (t.y = -t.y), C(t.u) || (t.S = Nr(t.u)), [Object.keys(t).reduce((s, i) => {
    const a = e(i);
    return a && (s[a] = t[i]), s;
  }, {}), n];
}
let Zt = null;
function qa() {
  return Zt || (Zt = b.fromMillis(1555555555555)), Zt;
}
function Ga(t, e) {
  if (t.literal)
    return t;
  const n = Q.macroTokenToFormatOpts(t.val);
  if (!n)
    return t;
  const i = Q.create(e, n).formatDateTimeParts(qa()).map((a) => Ba(a, e, n));
  return i.includes(void 0) ? t : i;
}
function Ja(t, e) {
  return Array.prototype.concat(...t.map((n) => Ga(n, e)));
}
function ns(t, e, n) {
  const r = Ja(Q.parseFormat(n), t), s = r.map((a) => Ya(a, t)), i = s.find((a) => a.invalidReason);
  if (i)
    return { input: e, tokens: r, invalidReason: i.invalidReason };
  {
    const [a, o] = Za(s), u = RegExp(a, "i"), [l, c] = Ua(e, u, o), [h, d] = c ? _a(c) : [null, null];
    if (Ue(c, "a") && Ue(c, "H"))
      throw new nt(
        "Can't include meridiem when specifying 24-hour format"
      );
    return { input: e, tokens: r, regex: u, rawMatches: l, matches: c, result: h, zone: d };
  }
}
function Ka(t, e, n) {
  const { result: r, zone: s, invalidReason: i } = ns(t, e, n);
  return [r, s, i];
}
const ss = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], is = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function oe(t, e) {
  return new he(
    "unit out of range",
    `you specified ${e} (of type ${typeof e}) as a ${t}, which is invalid`
  );
}
function as(t, e, n) {
  const r = new Date(Date.UTC(t, e - 1, n)).getUTCDay();
  return r === 0 ? 7 : r;
}
function os(t, e, n) {
  return n + (lt(t) ? is : ss)[e - 1];
}
function us(t, e) {
  const n = lt(t) ? is : ss, r = n.findIndex((i) => i < e), s = e - n[r];
  return { month: r + 1, day: s };
}
function nr(t) {
  const { year: e, month: n, day: r } = t, s = os(e, n, r), i = as(e, n, r);
  let a = Math.floor((s - i + 10) / 7), o;
  return a < 1 ? (o = e - 1, a = St(o)) : a > St(e) ? (o = e + 1, a = 1) : o = e, Object.assign({ weekYear: o, weekNumber: a, weekday: i }, Rt(t));
}
function ln(t) {
  const { weekYear: e, weekNumber: n, weekday: r } = t, s = as(e, 1, 4), i = st(e);
  let a = n * 7 + r - s - 3, o;
  a < 1 ? (o = e - 1, a += st(o)) : a > i ? (o = e + 1, a -= st(e)) : o = e;
  const { month: u, day: l } = us(o, a);
  return Object.assign({ year: o, month: u, day: l }, Rt(t));
}
function Ut(t) {
  const { year: e, month: n, day: r } = t, s = os(e, n, r);
  return Object.assign({ year: e, ordinal: s }, Rt(t));
}
function cn(t) {
  const { year: e, ordinal: n } = t, { month: r, day: s } = us(e, n);
  return Object.assign({ year: e, month: r, day: s }, Rt(t));
}
function Qa(t) {
  const e = Lt(t.weekYear), n = pe(t.weekNumber, 1, St(t.weekYear)), r = pe(t.weekday, 1, 7);
  return e ? n ? r ? !1 : oe("weekday", t.weekday) : oe("week", t.week) : oe("weekYear", t.weekYear);
}
function Xa(t) {
  const e = Lt(t.year), n = pe(t.ordinal, 1, st(t.year));
  return e ? n ? !1 : oe("ordinal", t.ordinal) : oe("year", t.year);
}
function ls(t) {
  const e = Lt(t.year), n = pe(t.month, 1, 12), r = pe(t.day, 1, xt(t.year, t.month));
  return e ? n ? r ? !1 : oe("day", t.day) : oe("month", t.month) : oe("year", t.year);
}
function cs(t) {
  const { hour: e, minute: n, second: r, millisecond: s } = t, i = pe(e, 0, 23) || e === 24 && n === 0 && r === 0 && s === 0, a = pe(n, 0, 59), o = pe(r, 0, 59), u = pe(s, 0, 999);
  return i ? a ? o ? u ? !1 : oe("millisecond", s) : oe("second", r) : oe("minute", n) : oe("hour", e);
}
const _t = "Invalid DateTime", dn = 864e13;
function mt(t) {
  return new he("unsupported zone", `the zone "${t.name}" is not supported`);
}
function qt(t) {
  return t.weekData === null && (t.weekData = nr(t.c)), t.weekData;
}
function Xe(t, e) {
  const n = {
    ts: t.ts,
    zone: t.zone,
    c: t.c,
    o: t.o,
    loc: t.loc,
    invalid: t.invalid
  };
  return new b(Object.assign({}, n, e, { old: n }));
}
function ds(t, e, n) {
  let r = t - e * 60 * 1e3;
  const s = n.offset(r);
  if (e === s)
    return [r, e];
  r -= (s - e) * 60 * 1e3;
  const i = n.offset(r);
  return s === i ? [r, s] : [t - Math.min(s, i) * 60 * 1e3, Math.max(s, i)];
}
function fn(t, e) {
  t += e * 60 * 1e3;
  const n = new Date(t);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function Mt(t, e, n) {
  return ds(Ar(t), e, n);
}
function hn(t, e) {
  const n = t.o, r = t.c.year + Math.trunc(e.years), s = t.c.month + Math.trunc(e.months) + Math.trunc(e.quarters) * 3, i = Object.assign({}, t.c, {
    year: r,
    month: s,
    day: Math.min(t.c.day, xt(r, s)) + Math.trunc(e.days) + Math.trunc(e.weeks) * 7
  }), a = I.fromObject({
    years: e.years - Math.trunc(e.years),
    quarters: e.quarters - Math.trunc(e.quarters),
    months: e.months - Math.trunc(e.months),
    weeks: e.weeks - Math.trunc(e.weeks),
    days: e.days - Math.trunc(e.days),
    hours: e.hours,
    minutes: e.minutes,
    seconds: e.seconds,
    milliseconds: e.milliseconds
  }).as("milliseconds"), o = Ar(i);
  let [u, l] = ds(o, n, t.zone);
  return a !== 0 && (u += a, l = t.zone.offset(u)), { ts: u, o: l };
}
function et(t, e, n, r, s) {
  const { setZone: i, zone: a } = n;
  if (t && Object.keys(t).length !== 0) {
    const o = e || a, u = b.fromObject(
      Object.assign(t, n, {
        zone: o,
        // setZone is a valid option in the calling methods, but not in fromObject
        setZone: void 0
      })
    );
    return i ? u : u.setZone(a);
  } else
    return b.invalid(
      new he("unparsable", `the input "${s}" can't be parsed as ${r}`)
    );
}
function He(t, e, n = !0) {
  return t.isValid ? Q.create(W.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(t, e) : null;
}
function mn(t, {
  suppressSeconds: e = !1,
  suppressMilliseconds: n = !1,
  includeOffset: r,
  includePrefix: s = !1,
  includeZone: i = !1,
  spaceZone: a = !1,
  format: o = "extended"
}) {
  let u = o === "basic" ? "HHmm" : "HH:mm";
  (!e || t.second !== 0 || t.millisecond !== 0) && (u += o === "basic" ? "ss" : ":ss", (!n || t.millisecond !== 0) && (u += ".SSS")), (i || r) && a && (u += " "), i ? u += "z" : r && (u += o === "basic" ? "ZZZ" : "ZZ");
  let l = He(t, u);
  return s && (l = "T" + l), l;
}
const fs = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, eo = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, to = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, hs = ["year", "month", "day", "hour", "minute", "second", "millisecond"], ro = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], no = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function yn(t) {
  const e = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[t.toLowerCase()];
  if (!e) throw new An(t);
  return e;
}
function gn(t, e) {
  for (const o of hs)
    C(t[o]) && (t[o] = fs[o]);
  const n = ls(t) || cs(t);
  if (n)
    return b.invalid(n);
  const r = j.now(), s = e.offset(r), [i, a] = Mt(t, s, e);
  return new b({
    ts: i,
    zone: e,
    o: a
  });
}
function pn(t, e, n) {
  const r = C(n.round) ? !0 : n.round, s = (a, o) => (a = Fr(a, r || n.calendary ? 0 : 2, !0), e.loc.clone(n).relFormatter(n).format(a, o)), i = (a) => n.calendary ? e.hasSame(t, a) ? 0 : e.startOf(a).diff(t.startOf(a), a).get(a) : e.diff(t, a).get(a);
  if (n.unit)
    return s(i(n.unit), n.unit);
  for (const a of n.units) {
    const o = i(a);
    if (Math.abs(o) >= 1)
      return s(o, a);
  }
  return s(t > e ? -0 : 0, n.units[n.units.length - 1]);
}
class b {
  /**
   * @access private
   */
  constructor(e) {
    const n = e.zone || j.defaultZone;
    let r = e.invalid || (Number.isNaN(e.ts) ? new he("invalid input") : null) || (n.isValid ? null : mt(n));
    this.ts = C(e.ts) ? j.now() : e.ts;
    let s = null, i = null;
    if (!r)
      if (e.old && e.old.ts === this.ts && e.old.zone.equals(n))
        [s, i] = [e.old.c, e.old.o];
      else {
        const o = n.offset(this.ts);
        s = fn(this.ts, o), r = Number.isNaN(s.year) ? new he("invalid input") : null, s = r ? null : s, i = r ? null : o;
      }
    this._zone = n, this.loc = e.loc || W.create(), this.invalid = r, this.weekData = null, this.c = s, this.o = i, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new b({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                            //~> now
   * @example DateTime.local(2017)                        //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                     //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12)                 //~> 2017-03-12T00:00:00
   * @example DateTime.local(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local(e, n, r, s, i, a, o) {
    return C(e) ? b.now() : gn(
      {
        year: e,
        month: n,
        day: r,
        hour: s,
        minute: i,
        second: a,
        millisecond: o
      },
      j.defaultZone
    );
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.utc()                            //~> now
   * @example DateTime.utc(2017)                        //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                     //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                 //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765Z
   * @return {DateTime}
   */
  static utc(e, n, r, s, i, a, o) {
    return C(e) ? new b({
      ts: j.now(),
      zone: q.utcInstance
    }) : gn(
      {
        year: e,
        month: n,
        day: r,
        hour: s,
        minute: i,
        second: a,
        millisecond: o
      },
      q.utcInstance
    );
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(e, n = {}) {
    const r = fi(e) ? e.valueOf() : NaN;
    if (Number.isNaN(r))
      return b.invalid("invalid input");
    const s = Ne(n.zone, j.defaultZone);
    return s.isValid ? new b({
      ts: r,
      zone: s,
      loc: W.fromObject(n)
    }) : b.invalid(mt(s));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(e, n = {}) {
    if (Ae(e))
      return e < -dn || e > dn ? b.invalid("Timestamp out of range") : new b({
        ts: e,
        zone: Ne(n.zone, j.defaultZone),
        loc: W.fromObject(n)
      });
    throw new ie(
      `fromMillis requires a numerical input, but received a ${typeof e} with value ${e}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(e, n = {}) {
    if (Ae(e))
      return new b({
        ts: e * 1e3,
        zone: Ne(n.zone, j.defaultZone),
        loc: W.fromObject(n)
      });
    throw new ie("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {string|Zone} [obj.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [obj.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} obj.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} obj.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */
  static fromObject(e) {
    const n = Ne(e.zone, j.defaultZone);
    if (!n.isValid)
      return b.invalid(mt(n));
    const r = j.now(), s = n.offset(r), i = Tt(e, yn, [
      "zone",
      "locale",
      "outputCalendar",
      "numberingSystem"
    ]), a = !C(i.ordinal), o = !C(i.year), u = !C(i.month) || !C(i.day), l = o || u, c = i.weekYear || i.weekNumber, h = W.fromObject(e);
    if ((l || a) && c)
      throw new nt(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (u && a)
      throw new nt("Can't mix ordinal dates with month/day");
    const d = c || i.weekday && !l;
    let m, p, w = fn(r, s);
    d ? (m = ro, p = eo, w = nr(w)) : a ? (m = no, p = to, w = Ut(w)) : (m = hs, p = fs);
    let D = !1;
    for (const Y of m) {
      const J = i[Y];
      C(J) ? D ? i[Y] = p[Y] : i[Y] = w[Y] : D = !0;
    }
    const S = d ? Qa(i) : a ? Xa(i) : ls(i), T = S || cs(i);
    if (T)
      return b.invalid(T);
    const H = d ? ln(i) : a ? cn(i) : i, [P, F] = Mt(H, s, n), E = new b({
      ts: P,
      zone: n,
      o: F,
      loc: h
    });
    return i.weekday && l && e.weekday !== E.weekday ? b.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${i.weekday} and a date of ${E.toISO()}`
    ) : E;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(e, n = {}) {
    const [r, s] = ga(e);
    return et(r, s, n, "ISO 8601", e);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(e, n = {}) {
    const [r, s] = pa(e);
    return et(r, s, n, "RFC 2822", e);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(e, n = {}) {
    const [r, s] = wa(e);
    return et(r, s, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @see https://moment.github.io/luxon/docs/manual/parsing.html#table-of-tokens
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(e, n, r = {}) {
    if (C(e) || C(n))
      throw new ie("fromFormat requires an input string and a format");
    const { locale: s = null, numberingSystem: i = null } = r, a = W.fromOpts({
      locale: s,
      numberingSystem: i,
      defaultToEN: !0
    }), [o, u, l] = Ka(a, e, n);
    return l ? b.invalid(l) : et(o, u, r, `format ${n}`, e);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(e, n, r = {}) {
    return b.fromFormat(e, n, r);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(e, n = {}) {
    const [r, s] = Ta(e);
    return et(r, s, n, "SQL", e);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new ie("need to specify a reason the DateTime is invalid");
    const r = e instanceof he ? e : new he(e, n);
    if (j.throwOnInvalid)
      throw new ui(r);
    return new b({ invalid: r });
  }
  /**
   * Check if an object is a DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(e) {
    return e && e.isLuxonDateTime || !1;
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(e) {
    return this[e];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? qt(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? qt(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? qt(this).weekday : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? Ut(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? ze.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? ze.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? ze.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? ze.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.universal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return lt(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return xt(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? st(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? St(this.weekYear) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOpts(e = {}) {
    const { locale: n, numberingSystem: r, calendar: s } = Q.create(
      this.loc.clone(e),
      e
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: r, outputCalendar: s };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(e = 0, n = {}) {
    return this.setZone(q.instance(e), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(j.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link plus}. You may wish to use {@link toLocal} and {@link toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(e, { keepLocalTime: n = !1, keepCalendarTime: r = !1 } = {}) {
    if (e = Ne(e, j.defaultZone), e.equals(this.zone))
      return this;
    if (e.isValid) {
      let s = this.ts;
      if (n || r) {
        const i = e.offset(this.ts), a = this.toObject();
        [s] = Mt(a, i, e);
      }
      return Xe(this, { ts: s, zone: e });
    } else
      return b.invalid(mt(e));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: e, numberingSystem: n, outputCalendar: r } = {}) {
    const s = this.loc.clone({ locale: e, numberingSystem: n, outputCalendar: r });
    return Xe(this, { loc: s });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(e) {
    return this.reconfigure({ locale: e });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link reconfigure} and {@link setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = Tt(e, yn, []), r = !C(n.weekYear) || !C(n.weekNumber) || !C(n.weekday), s = !C(n.ordinal), i = !C(n.year), a = !C(n.month) || !C(n.day), o = i || a, u = n.weekYear || n.weekNumber;
    if ((o || s) && u)
      throw new nt(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (a && s)
      throw new nt("Can't mix ordinal dates with month/day");
    let l;
    r ? l = ln(Object.assign(nr(this.c), n)) : C(n.ordinal) ? (l = Object.assign(this.toObject(), n), C(n.day) && (l.day = Math.min(xt(l.year, l.month), l.day))) : l = cn(Object.assign(Ut(this.c), n));
    const [c, h] = Mt(l, this.o, this.zone);
    return Xe(this, { ts: c, o: h });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = Fe(e);
    return Xe(this, hn(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
  */
  minus(e) {
    if (!this.isValid) return this;
    const n = Fe(e).negate();
    return Xe(this, hn(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(e) {
    if (!this.isValid) return this;
    const n = {}, r = I.normalizeUnit(e);
    switch (r) {
      case "years":
        n.month = 1;
      case "quarters":
      case "months":
        n.day = 1;
      case "weeks":
      case "days":
        n.hour = 0;
      case "hours":
        n.minute = 0;
      case "minutes":
        n.second = 0;
      case "seconds":
        n.millisecond = 0;
        break;
    }
    if (r === "weeks" && (n.weekday = 1), r === "quarters") {
      const s = Math.ceil(this.month / 3);
      n.month = (s - 1) * 3 + 1;
    }
    return this.set(n);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(e) {
    return this.isValid ? this.plus({ [e]: 1 }).startOf(e).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @see https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(e, n = {}) {
    return this.isValid ? Q.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, e) : _t;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param opts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hour12: false }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(e = kt) {
    return this.isValid ? Q.create(this.loc.clone(e), e).formatDateTime(this) : _t;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(e = {}) {
    return this.isValid ? Q.create(this.loc.clone(e), e).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO(e = {}) {
    return this.isValid ? `${this.toISODate(e)}T${this.toISOTime(e)}` : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: e = "extended" } = {}) {
    let n = e === "basic" ? "yyyyMMdd" : "yyyy-MM-dd";
    return this.year > 9999 && (n = "+" + n), He(this, n);
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return He(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: e = !1,
    suppressSeconds: n = !1,
    includeOffset: r = !0,
    includePrefix: s = !1,
    format: i = "extended"
  } = {}) {
    return mn(this, {
      suppressSeconds: n,
      suppressMilliseconds: e,
      includeOffset: r,
      includePrefix: s,
      format: i
    });
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime, always in UTC
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return He(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return He(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return He(this, "yyyy-MM-dd");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: e = !0, includeZone: n = !1 } = {}) {
    return mn(this, {
      includeOffset: e,
      includeZone: n,
      spaceZone: !0
    });
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(e = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(e)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : _t;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(e = {}) {
    if (!this.isValid) return {};
    const n = Object.assign({}, this.c);
    return e.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(e, n = "milliseconds", r = {}) {
    if (!this.isValid || !e.isValid)
      return I.invalid(
        this.invalid || e.invalid,
        "created by diffing an invalid DateTime"
      );
    const s = Object.assign(
      { locale: this.locale, numberingSystem: this.numberingSystem },
      r
    ), i = hi(n).map(I.normalizeUnit), a = e.valueOf() > this.valueOf(), o = a ? this : e, u = a ? e : this, l = Pa(o, u, i, s);
    return a ? l.negate() : l;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(e = "milliseconds", n = {}) {
    return this.diff(b.now(), e, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(e) {
    return this.isValid ? z.fromDateTimes(this, e) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(e, n) {
    if (!this.isValid) return !1;
    const r = e.valueOf(), s = this.setZone(e.zone, { keepLocalTime: !0 });
    return s.startOf(n) <= r && r <= s.endOf(n);
  }
  /**
   * Equality check
   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(e) {
    return this.isValid && e.isValid && this.valueOf() === e.valueOf() && this.zone.equals(e.zone) && this.loc.equals(e.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(e = {}) {
    if (!this.isValid) return null;
    const n = e.base || b.fromObject({ zone: this.zone }), r = e.padding ? this < n ? -e.padding : e.padding : 0;
    let s = ["years", "months", "days", "hours", "minutes", "seconds"], i = e.unit;
    return Array.isArray(e.unit) && (s = e.unit, i = void 0), pn(
      n,
      this.plus(r),
      Object.assign(e, {
        numeric: "always",
        units: s,
        unit: i
      })
    );
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(e = {}) {
    return this.isValid ? pn(
      e.base || b.fromObject({ zone: this.zone }),
      this,
      Object.assign(e, {
        numeric: "auto",
        units: ["years", "months", "days"],
        calendary: !0
      })
    ) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...e) {
    if (!e.every(b.isDateTime))
      throw new ie("min requires all arguments be DateTimes");
    return qr(e, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...e) {
    if (!e.every(b.isDateTime))
      throw new ie("max requires all arguments be DateTimes");
    return qr(e, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(e, n, r = {}) {
    const { locale: s = null, numberingSystem: i = null } = r, a = W.fromOpts({
      locale: s,
      numberingSystem: i,
      defaultToEN: !0
    });
    return ns(a, e, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(e, n, r = {}) {
    return b.fromFormatExplain(e, n, r);
  }
  // FORMAT PRESETS
  /**
   * {@link toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return kt;
  }
  /**
   * {@link toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return dr;
  }
  /**
   * {@link toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return In;
  }
  /**
   * {@link toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return fr;
  }
  /**
   * {@link toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return hr;
  }
  /**
   * {@link toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return mr;
  }
  /**
   * {@link toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return yr;
  }
  /**
   * {@link toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return gr;
  }
  /**
   * {@link toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return pr;
  }
  /**
   * {@link toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return wr;
  }
  /**
   * {@link toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return br;
  }
  /**
   * {@link toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return vr;
  }
  /**
   * {@link toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return Mr;
  }
  /**
   * {@link toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return Dr;
  }
  /**
   * {@link toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return kr;
  }
  /**
   * {@link toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return xr;
  }
  /**
   * {@link toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return Sr;
  }
  /**
   * {@link toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return Ln;
  }
  /**
   * {@link toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return Tr;
  }
  /**
   * {@link toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return Or;
  }
  /**
   * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return Cr;
  }
  /**
   * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return Er;
  }
}
function tt(t) {
  if (b.isDateTime(t))
    return t;
  if (t && t.valueOf && Ae(t.valueOf()))
    return b.fromJSDate(t);
  if (t && typeof t == "object")
    return b.fromObject(t);
  throw new ie(
    `Unknown datetime argument: ${t}, of type ${typeof t}`
  );
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var ms = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Ct = /* @__PURE__ */ ms.join(","), ys = typeof Element > "u", Ie = ys ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Et = !ys && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t == null ? void 0 : t.ownerDocument;
}, Nt = function t(e, n) {
  var r;
  n === void 0 && (n = !0);
  var s = e == null || (r = e.getAttribute) === null || r === void 0 ? void 0 : r.call(e, "inert"), i = s === "" || s === "true", a = i || n && e && t(e.parentNode);
  return a;
}, so = function(e) {
  var n, r = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "contenteditable");
  return r === "" || r === "true";
}, gs = function(e, n, r) {
  if (Nt(e))
    return [];
  var s = Array.prototype.slice.apply(e.querySelectorAll(Ct));
  return n && Ie.call(e, Ct) && s.unshift(e), s = s.filter(r), s;
}, ps = function t(e, n, r) {
  for (var s = [], i = Array.from(e); i.length; ) {
    var a = i.shift();
    if (!Nt(a, !1))
      if (a.tagName === "SLOT") {
        var o = a.assignedElements(), u = o.length ? o : a.children, l = t(u, !0, r);
        r.flatten ? s.push.apply(s, l) : s.push({
          scopeParent: a,
          candidates: l
        });
      } else {
        var c = Ie.call(a, Ct);
        c && r.filter(a) && (n || !e.includes(a)) && s.push(a);
        var h = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), d = !Nt(h, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (h && d) {
          var m = t(h === !0 ? a.children : h.children, !0, r);
          r.flatten ? s.push.apply(s, m) : s.push({
            scopeParent: a,
            candidates: m
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return s;
}, ws = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, jr = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || so(e)) && !ws(e) ? 0 : e.tabIndex;
}, io = function(e, n) {
  var r = jr(e);
  return r < 0 && n && !ws(e) ? 0 : r;
}, ao = function(e, n) {
  return e.tabIndex === n.tabIndex ? e.documentOrder - n.documentOrder : e.tabIndex - n.tabIndex;
}, bs = function(e) {
  return e.tagName === "INPUT";
}, oo = function(e) {
  return bs(e) && e.type === "hidden";
}, uo = function(e) {
  var n = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, lo = function(e, n) {
  for (var r = 0; r < e.length; r++)
    if (e[r].checked && e[r].form === n)
      return e[r];
}, co = function(e) {
  if (!e.name)
    return !0;
  var n = e.form || Et(e), r = function(o) {
    return n.querySelectorAll('input[type="radio"][name="' + o + '"]');
  }, s;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    s = r(window.CSS.escape(e.name));
  else
    try {
      s = r(e.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = lo(s, e.form);
  return !i || i === e;
}, fo = function(e) {
  return bs(e) && e.type === "radio";
}, ho = function(e) {
  return fo(e) && !co(e);
}, mo = function(e) {
  var n, r = e && Et(e), s = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== e) {
    var a, o, u;
    for (i = !!((a = s) !== null && a !== void 0 && (o = a.ownerDocument) !== null && o !== void 0 && o.contains(s) || e != null && (u = e.ownerDocument) !== null && u !== void 0 && u.contains(e)); !i && s; ) {
      var l, c, h;
      r = Et(s), s = (l = r) === null || l === void 0 ? void 0 : l.host, i = !!((c = s) !== null && c !== void 0 && (h = c.ownerDocument) !== null && h !== void 0 && h.contains(s));
    }
  }
  return i;
}, wn = function(e) {
  var n = e.getBoundingClientRect(), r = n.width, s = n.height;
  return r === 0 && s === 0;
}, yo = function(e, n) {
  var r = n.displayCheck, s = n.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var i = Ie.call(e, "details>summary:first-of-type"), a = i ? e.parentElement : e;
  if (Ie.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof s == "function") {
      for (var o = e; e; ) {
        var u = e.parentElement, l = Et(e);
        if (u && !u.shadowRoot && s(u) === !0)
          return wn(e);
        e.assignedSlot ? e = e.assignedSlot : !u && l !== e.ownerDocument ? e = l.host : e = u;
      }
      e = o;
    }
    if (mo(e))
      return !e.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return wn(e);
  return !1;
}, go = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var n = e.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var s = n.children.item(r);
          if (s.tagName === "LEGEND")
            return Ie.call(n, "fieldset[disabled] *") ? !0 : !s.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Ft = function(e, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Nt(n) || oo(n) || yo(n, e) || // For a details element with a summary, the summary element gets the focus
  uo(n) || go(n));
}, sr = function(e, n) {
  return !(ho(n) || jr(n) < 0 || !Ft(e, n));
}, po = function(e) {
  var n = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, wo = function t(e) {
  var n = [], r = [];
  return e.forEach(function(s, i) {
    var a = !!s.scopeParent, o = a ? s.scopeParent : s, u = io(o, a), l = a ? t(s.candidates) : o;
    u === 0 ? a ? n.push.apply(n, l) : n.push(o) : r.push({
      documentOrder: i,
      tabIndex: u,
      item: s,
      isScope: a,
      content: l
    });
  }), r.sort(ao).reduce(function(s, i) {
    return i.isScope ? s.push.apply(s, i.content) : s.push(i.content), s;
  }, []).concat(n);
}, bo = function(e, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = ps([e], n.includeContainer, {
    filter: sr.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: po
  }) : r = gs(e, n.includeContainer, sr.bind(null, n)), wo(r);
}, vo = function(e, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = ps([e], n.includeContainer, {
    filter: Ft.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = gs(e, n.includeContainer, Ft.bind(null, n)), r;
}, Mo = function(e, n) {
  if (n = n || {}, !e)
    throw new Error("No node provided");
  return Ie.call(e, Ct) === !1 ? !1 : sr(n, e);
}, Do = /* @__PURE__ */ ms.concat("iframe").join(","), ko = function(e, n) {
  if (n = n || {}, !e)
    throw new Error("No node provided");
  return Ie.call(e, Do) === !1 ? !1 : Ft(n, e);
};
const dc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  focusable: vo,
  getTabIndex: jr,
  isFocusable: ko,
  isTabbable: Mo,
  tabbable: bo
}, Symbol.toStringTag, { value: "Module" })), xo = {
  dayOfMonth: "d",
  fullDate: "DD",
  fullDateWithWeekday: "DDDD",
  fullDateTime: "ff",
  fullDateTime12h: "DD, hh:mm a",
  fullDateTime24h: "DD, T",
  fullTime: "t",
  fullTime12h: "hh:mm a",
  fullTime24h: "HH:mm",
  hours12h: "hh",
  hours24h: "HH",
  keyboardDate: "D",
  keyboardDateTime: "D t",
  keyboardDateTime12h: "D hh:mm a",
  keyboardDateTime24h: "D T",
  minutes: "mm",
  seconds: "ss",
  month: "LLLL",
  monthAndDate: "MMMM d",
  monthAndYear: "LLLL yyyy",
  monthShort: "MMM",
  weekday: "cccc",
  weekdayShort: "ccc",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  shortDate: "MMM d",
  year: "yyyy"
};
class So {
  constructor({ locale: e, formats: n } = {}) {
    this.lib = "luxon", this.date = (r) => typeof r > "u" ? b.local() : r === null ? null : typeof r == "string" ? b.fromJSDate(new Date(r), { locale: this.locale }) : b.isDateTime(r) ? r : b.fromJSDate(r, { locale: this.locale }), this.toJsDate = (r) => r.toJSDate(), this.parseISO = (r) => b.fromISO(r), this.toISO = (r) => r.toISO({ format: "extended" }), this.parse = (r, s) => r === "" ? null : b.fromFormat(r, s, { locale: this.locale }), this.is12HourCycleInCurrentLocale = () => {
      var r, s;
      return typeof Intl > "u" || typeof Intl.DateTimeFormat > "u" ? !0 : !!(!((s = (r = new Intl.DateTimeFormat(this.locale, { hour: "numeric" })) === null || r === void 0 ? void 0 : r.resolvedOptions()) === null || s === void 0) && s.hour12);
    }, this.getFormatHelperText = (r) => "", this.getCurrentLocaleCode = () => this.locale || j.defaultLocale, this.addSeconds = (r, s) => r.plus({ seconds: s }), this.addMinutes = (r, s) => r.plus({ minutes: s }), this.addHours = (r, s) => r.plus({ hours: s }), this.addDays = (r, s) => r.plus({ days: s }), this.addWeeks = (r, s) => r.plus({ weeks: s }), this.addMonths = (r, s) => r.plus({ months: s }), this.addYears = (r, s) => r.plus({ years: s }), this.isValid = (r) => {
      var s, i;
      return b.isDateTime(r) ? r.isValid : r === null ? !1 : (i = (s = this.date(r)) === null || s === void 0 ? void 0 : s.isValid) !== null && i !== void 0 ? i : !1;
    }, this.isEqual = (r, s) => {
      var i, a;
      return r === null && s === null ? !0 : r === null || s === null || !this.date(s) ? !1 : (a = (i = this.date(r)) === null || i === void 0 ? void 0 : i.equals(this.date(s))) !== null && a !== void 0 ? a : !1;
    }, this.isSameDay = (r, s) => r.hasSame(s, "day"), this.isSameMonth = (r, s) => r.hasSame(s, "month"), this.isSameYear = (r, s) => r.hasSame(s, "year"), this.isSameHour = (r, s) => r.hasSame(s, "hour"), this.isAfter = (r, s) => r > s, this.isBefore = (r, s) => r < s, this.isBeforeDay = (r, s) => r.diff(s.startOf("day"), "days").toObject().days < 0, this.isAfterDay = (r, s) => r.diff(s.endOf("day"), "days").toObject().days > 0, this.isBeforeMonth = (r, s) => r.diff(s.startOf("month"), "months").toObject().months < 0, this.isAfterMonth = (r, s) => r.diff(s.startOf("month"), "months").toObject().months > 0, this.isBeforeYear = (r, s) => r.diff(s.startOf("year"), "years").toObject().years < 0, this.isAfterYear = (r, s) => r.diff(s.endOf("year"), "years").toObject().years > 0, this.getDiff = (r, s, i) => (typeof s == "string" && (s = b.fromJSDate(new Date(s))), s.isValid ? i ? Math.floor(r.diff(s).as(i)) : r.diff(s).as("millisecond") : 0), this.startOfDay = (r) => r.startOf("day"), this.endOfDay = (r) => r.endOf("day"), this.format = (r, s) => this.formatByString(r, this.formats[s]), this.formatByString = (r, s) => r.setLocale(this.locale).toFormat(s), this.formatNumber = (r) => r, this.getHours = (r) => r.get("hour"), this.setHours = (r, s) => r.set({ hour: s }), this.getMinutes = (r) => r.get("minute"), this.setMinutes = (r, s) => r.set({ minute: s }), this.getSeconds = (r) => r.get("second"), this.setSeconds = (r, s) => r.set({ second: s }), this.getMonth = (r) => r.get("month") - 1, this.getDaysInMonth = (r) => r.daysInMonth, this.setMonth = (r, s) => r.set({ month: s + 1 }), this.getYear = (r) => r.get("year"), this.setYear = (r, s) => r.set({ year: s }), this.getDate = (r) => r.get("day"), this.setDate = (r, s) => r.set({ day: s }), this.mergeDateAndTime = (r, s) => r.set({
      second: s.second,
      hour: s.hour,
      minute: s.minute
    }), this.startOfYear = (r) => r.startOf("year"), this.endOfYear = (r) => r.endOf("year"), this.startOfMonth = (r) => r.startOf("month"), this.endOfMonth = (r) => r.endOf("month"), this.startOfWeek = (r) => r.startOf("week"), this.endOfWeek = (r) => r.endOf("week"), this.getNextMonth = (r) => r.plus({ months: 1 }), this.getPreviousMonth = (r) => r.minus({ months: 1 }), this.getMonthArray = (r) => {
      const i = [r.startOf("year")];
      for (; i.length < 12; ) {
        const a = i[i.length - 1];
        i.push(this.getNextMonth(a));
      }
      return i;
    }, this.getWeekdays = () => ze.weekdaysFormat("short", { locale: this.locale }), this.getWeekArray = (r) => {
      const { days: s } = r.endOf("month").endOf("week").diff(r.startOf("month").startOf("week"), "days").toObject(), i = [];
      return new Array(Math.round(s)).fill(0).map((a, o) => o).map((a) => r.startOf("month").startOf("week").plus({ days: a })).forEach((a, o) => {
        if (o === 0 || o % 7 === 0 && o > 6) {
          i.push([a]);
          return;
        }
        i[i.length - 1].push(a);
      }), i;
    }, this.getYearRange = (r, s) => {
      const i = r.startOf("year"), a = s.endOf("year");
      let o = i;
      const u = [];
      for (; o < a; )
        u.push(o), o = o.plus({ year: 1 });
      return u;
    }, this.getMeridiemText = (r) => ze.meridiems({ locale: this.locale }).find((s) => s.toLowerCase() === r.toLowerCase()), this.isNull = (r) => r === null, this.isWithinRange = (r, [s, i]) => r.equals(s) || r.equals(i) || this.isAfter(r, s) && this.isBefore(r, i), this.locale = e || "en-US", this.formats = Object.assign({}, xo, n);
  }
}
function $r(t = "us") {
  return t = t.toLowerCase(), t === "de" ? {
    monthAbbreviations: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    startOfWeek: 1,
    weekdayAbbreviations: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"]
  } : t === "es" || t === "es-ar" ? {
    monthAbbreviations: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    startOfWeek: 0,
    weekdayAbbreviations: ["do", "lu", "ma", "mi", "ju", "vi", "sá"]
  } : t === "fr" || t === "fr-ca" ? {
    monthAbbreviations: ["Jan", "Fév", "Mar", "Avr", "Mai", "Jun", "Jui", "Aoû", "Sep", "Oct", "Nov", "Déc"],
    startOfWeek: 0,
    weekdayAbbreviations: ["di", "lu", "ma", "me", "je", "ve", "sa"]
  } : t === "ja" ? {
    monthAbbreviations: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
    startOfWeek: 0,
    weekdayAbbreviations: ["日", "月", "火", "水", "木", "金", "土"]
  } : t === "nl" ? {
    monthAbbreviations: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
    startOfWeek: 1,
    weekdayAbbreviations: ["zo", "ma", "di", "wo", "do", "vr", "za"]
  } : t === "pt" || t === "pt-br" ? {
    monthAbbreviations: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    startOfWeek: 0,
    weekdayAbbreviations: ["do", "se", "te", "qu", "qu", "se", "sá"]
  } : t === "zh" || t === "zh-cn" ? {
    monthAbbreviations: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
    startOfWeek: 0,
    weekdayAbbreviations: ["日", "一", "二", "三", "四", "五", "六"]
  } : {
    monthAbbreviations: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    startOfWeek: 0,
    weekdayAbbreviations: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
  };
}
function To(t, e) {
  const n = t.locale, r = $r(n);
  if (r) {
    const s = t.startOfMonth(e), i = t.getDiff(s, t.startOfWeek(s), "days") + 1, a = t.getDaysInMonth(e), o = (i - r.startOfWeek + 7) % 7, u = t.addDays(s, -o), l = Math.ceil((o + a) / 7), c = [];
    for (let h = 0; h < l; h++) {
      const d = [];
      for (let m = 0; m < 7; m++)
        d.push(t.addDays(u, h * 7 + m));
      c.push(d);
    }
    return c;
  }
}
function Oo(t) {
  const e = $r(t), n = [...e.weekdayAbbreviations], r = n.splice(0, e.startOfWeek);
  return n.push(...r), n;
}
class Co extends So {
  constructor() {
    super(...arguments), this.getWeekArray = (e) => To(this, e), this.getWeekdays = () => Oo(this.locale);
  }
}
function vs() {
  const { utils: t } = kn(Cn);
  return t;
}
const fc = (t, e) => Rs(() => e ? t.getWeekArray(e).length : 4, [t, e]);
function Eo(t) {
  const e = t.split(""), n = t.length, r = e.shift(), s = [];
  for (; e.length; )
    s.push(e.join("")), e.pop();
  const i = `^${r}(?:${s.join("|")})?`;
  return {
    regex: new RegExp(i, "i"),
    maxLength: n
  };
}
function No(t) {
  return t.map((e) => Eo(e));
}
function Fo(t) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  const e = t.locale, n = $r(e);
  return n ? n.monthAbbreviations : Ao(t);
}
function Ao(t) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  const e = [];
  for (let n = 0; n < 12; n++) {
    const r = new Date(1970, n, 2);
    e.push(t.format(t.date(r), "monthShort"));
  }
  return e;
}
function xe(t, e, n, r) {
  if (!t || !e || !k(t, e) || !Be.isFinite(n) || !r)
    throw new Error("Expected arguments are missing.");
  return r === "day" ? t.addDays(e, n) : r === "month" ? t.setMonth(e, t.getMonth(e) + n) : r === "year" ? t.setYear(e, t.getYear(e) + n) : e;
}
function At(t, e, n, r, s, i, a) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  if (!e)
    return n ? "invalid" : r ? "required" : void 0;
  if (!t.isValid(e))
    return "invalid";
  if (s && k(t, s) && t.isBeforeDay(e, s))
    return "beforeMin";
  if (i && k(t, i) && t.isAfterDay(e, i))
    return "afterMax";
  if (a && a(e))
    return "disabled";
}
function hc(t, e) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  if (!e)
    return;
  const n = e.slice(0, 10);
  if (!Zo.test(n))
    return;
  const r = t.parse(n, t.formats.isoDate);
  return k(t, r) ? r : void 0;
}
function Ms(t, e, n) {
  if (!t || !e || !n)
    throw new Error("Expected arguments are missing.");
  if (n < 1 || n > 12)
    throw new Error("Month values must be within the range of 1 and 12.");
  return t.date(new Date(e, n - 1));
}
function mc(t, e) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  let n, r, s, i;
  return e && k(t, e) && (n = t.format(e, "isoDate"), r = t.getYear(e), s = t.getMonth(e) + 1, i = Number(t.format(e, "dayOfMonth"))), {
    date: n,
    day: i,
    month: s,
    year: r
  };
}
function yc(t) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  const e = Ds(t);
  return t.setYear(e, t.getYear(e) + 100);
}
function gc(t) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  const e = Ds(t);
  return t.setYear(e, t.getYear(e) - 100);
}
function Wr(t, e, n, r, s) {
  if (!t || !e || !k(t, e))
    throw new Error("Expected arguments are missing.");
  return !!n && k(t, n) && t.isBeforeDay(e, n) || !!r && k(t, r) && t.isAfterDay(e, r) || !!s && s(e);
}
function pc(t, e, n, r) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  if (!e || !k(t, e))
    throw new Error("An invalid date was supplied.");
  const s = Ms(t, r, n + 1);
  let i;
  return Lo(t, e) > t.getDaysInMonth(s) ? i = t.startOfDay(t.endOfMonth(s)) : i = t.setMonth(t.setYear(e, r), n), i;
}
function k(t, e) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  return !!e && t.isValid(e);
}
function wc(t, e, n) {
  if (!t || !e || !k(t, e) || !n || !k(t, n))
    throw new Error("Expected arguments are missing.");
  const r = t.startOfMonth(t.getNextMonth(e));
  return t.isAfterDay(r, n);
}
function bc(t, e, n) {
  if (!t || !e || !k(t, e) || !n || !k(t, n))
    throw new Error("Expected arguments are missing.");
  const r = t.endOfMonth(t.getPreviousMonth(e));
  return t.isBeforeDay(r, n);
}
function vc(t) {
  return ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "PageUp", "PageDown"].includes(t.key);
}
function Io(t, e, n, r) {
  return n === "ArrowUp" ? e = xe(t, e, -7, "day") : n === "ArrowDown" ? e = xe(t, e, 7, "day") : n === "ArrowLeft" ? e = xe(t, e, -1, "day") : n === "ArrowRight" ? e = xe(t, e, 1, "day") : r && n === "PageUp" ? e = xe(t, e, -1, "year") : r && n === "PageDown" ? e = xe(t, e, 1, "year") : n === "PageUp" ? e = xe(t, e, -1, "month") : n === "PageDown" && (e = xe(t, e, 1, "month")), e;
}
function Ds(t) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  return t.startOfDay(t.date());
}
function Lo(t, e) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  if (!e || !k(t, e))
    throw new Error("Expected arguments are missing.");
  return Number(t.format(e, "dayOfMonth"));
}
function Mc(t, e, n) {
  if (!t || !e)
    throw new Error("Expected arguments are missing.");
  let r = t.parse(n, e);
  return (!r || !t.isValid(r)) && (r = void 0), r;
}
const Po = (t, e) => t && e ? {
  error: "invalid",
  type: "range"
} : t ? {
  error: "invalid",
  type: "start"
} : e ? {
  error: "invalid",
  type: "end"
} : {
  error: "required",
  type: "range"
};
function Ro(t, e, n, r, s, i, a, o, u, l, c) {
  if ((i || a && o) && !e && !n)
    return Po(r, s);
  const d = At(t, e, r, i || a, u, l, c);
  if (d)
    return {
      error: d,
      type: "start"
    };
  const m = At(t, n, s, i || o, u, l, c);
  if (m)
    return {
      error: m,
      type: "end"
    };
}
function Dc(t, e, n, r) {
  if (!t || !e || !k(t, e) || !n || !k(t, n) || !r || !k(t, r))
    throw new Error("Expected arguments are missing.");
  return t.isAfterDay(e, n) && t.isBeforeDay(e, r);
}
function Vo(t, e, n, r) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  if (!r || !e || !k(t, e) || !n || !k(t, n))
    return !1;
  const s = t.getYear(e), i = t.setYear(e, s - r), a = t.setYear(e, s + r);
  return t.isBeforeDay(n, i) || t.isAfterDay(n, a);
}
function kc(t, e, n) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  return k(t, e) && k(t, n) ? "complete" : k(t, e) ? "onlyStart" : k(t, n) ? "onlyEnd" : "empty";
}
function jo(t, e, n, r, s, i, a, o, u) {
  if (!t || !e || !k(t, e))
    throw new Error("Expected arguments are missing.");
  return !!s && k(t, s) && t.isBeforeDay(e, s) || !!i && k(t, i) && t.isAfterDay(e, i) || u && !!r && k(t, r) && t.isAfterDay(e, r) || o && !!n && k(t, n) && t.isBeforeDay(e, n) || !!a && a(e);
}
function xc(t, e, n, r, s, i, a, o, u, l, c, h, d, m, p) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  if (!e || !n)
    return Ro(
      t,
      e,
      n,
      r,
      s,
      i,
      a,
      o,
      l,
      c,
      d
    );
  if (!k(t, e) && !k(t, n))
    return {
      error: "invalid",
      type: "range"
    };
  if (k(t, e) && k(t, n)) {
    if (t.isAfterDay(e, n) || t.isBeforeDay(n, e))
      return {
        error: "invalid",
        type: "range"
      };
    if (h && Vo(t, e, n, h))
      return {
        error: "tooLarge",
        type: "range"
      };
    if (u && $o(t, e, n, (S) => jo(
      t,
      S,
      e,
      n,
      l,
      c,
      d,
      m,
      p
    )))
      return {
        error: "includesDisabled",
        type: "range"
      };
  }
  const w = At(t, e, r, !0, l, c, d);
  if (w)
    return {
      error: w,
      type: "start"
    };
  const D = At(t, n, s, !0, l, c, d);
  if (D)
    return {
      error: D,
      type: "end"
    };
}
function $o(t, e, n, r) {
  if (!t || !e || !k(t, e) || !n || !k(t, n) || !r)
    throw new Error("Expected arguments are missing.");
  const s = t.startOfDay(e), i = t.startOfDay(n), a = t.getDiff(i, s) / Bo;
  for (let o = 0; o <= a; o++) {
    const u = t.addDays(s, o);
    if (r(u))
      return !0;
  }
  return !1;
}
function Sc(t, e, n) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  let r = e, s = n;
  return e && k(t, e) && n && k(t, n) && t.isBeforeDay(n, e) && (r = n, s = e), {
    startDate: r,
    endDate: s
  };
}
function Tc(t, e, n) {
  if (!t || !e || !k(t, e) || !n || !k(t, n))
    throw new Error("Expected arguments are missing.");
  const r = [], s = t.getYear(e), a = t.getYear(n) - s + 1;
  for (let o = 0; o < a; o++)
    r.push(s + o);
  return r;
}
function Wo(t, e, n) {
  const { getDateDisabled: r, maxDate: s, minDate: i } = n;
  let a = e;
  for (; t.isBefore(a, s) || t.isSameDay(a, s); )
    if (a = t.addDays(a, 1), !Wr(t, a, i, s, r))
      return a;
}
function Ho(t, e, n) {
  const { getDateDisabled: r, maxDate: s, minDate: i } = n;
  let a = e;
  for (; t.isAfter(a, i) || t.isSameDay(a, i); )
    if (a = t.addDays(a, -1), !Wr(t, a, i, s, r))
      return a;
}
function Oc(t, e, n) {
  return {
    next: Wo(t, e, n),
    previous: Ho(t, e, n)
  };
}
function Cc(t, e, n, r = {}) {
  const { getDateDisabled: s, maxDate: i, minDate: a } = r;
  let o = a;
  (!o || t.isBeforeDay(a, e)) && (o = e);
  let u = i;
  return (!u || t.isAfterDay(i, n)) && (u = t.startOfDay(t.endOfMonth(n))), { getDateDisabled: s, maxDate: u, minDate: o };
}
function Yo({
  isAtLimit: t,
  isEnabled: e,
  navigator: n,
  value: r
}) {
  let s = r;
  for (; !t(s); )
    if (s = n(s), e(s))
      return s;
  return r;
}
function zo(t, { maxDate: e, minDate: n }, r) {
  return !!n && t.isBefore(r, n) || !!e && t.isAfter(r, e);
}
const Ec = 300, Nc = 120, Bo = 1e3 * 60 * 60 * 24, Zo = /^\d\d\d\d-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])$/, yt = {
  fixedLength: 2,
  regex: /^(?:0[1-9]?|[1-2][0-9]?|3[0-1]?)/
}, Gt = {
  fixedLength: 2,
  regex: /^(?:0[1-9]?|1[0-2]?)/
}, gt = {
  fixedLength: 4,
  regex: /^\d{1,4}/
}, Uo = /^[4-9]/, _o = /^[2-9]/, pt = (t) => {
  const e = Uo.exec(t);
  return e ? `0${e[0]}` : t;
}, Jt = (t) => {
  const e = _o.exec(t);
  return e ? `0${e[0]}` : t;
};
function Fc(t) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  const e = t.formats.fullDate;
  return e === "dd/MM/yyyy" ? {
    delimiterChar: "/",
    order: ["day", "month", "year"],
    parts: {
      day: {
        mask: "dd",
        matchers: [yt],
        preMatchHook: pt
      },
      month: {
        mask: "mm",
        matchers: [Gt],
        preMatchHook: Jt
      },
      year: {
        mask: "yyyy",
        matchers: [gt]
      }
    }
  } : e === "yyyy-MM-dd" ? {
    delimiterChar: "-",
    order: ["year", "month", "day"],
    parts: {
      day: {
        mask: "dd",
        matchers: [yt],
        preMatchHook: pt
      },
      month: {
        mask: "mm",
        matchers: [Gt],
        preMatchHook: Jt
      },
      year: {
        mask: "yyyy",
        matchers: [gt]
      }
    }
  } : e === "dd MMM yyyy" ? {
    delimiterChar: " ",
    order: ["day", "month", "year"],
    parts: {
      day: {
        mask: "dd",
        matchers: [yt],
        preMatchHook: pt
      },
      month: {
        mask: "mon",
        matchers: No(Fo(t))
      },
      year: {
        mask: "yyyy",
        matchers: [gt]
      }
    }
  } : {
    delimiterChar: "/",
    order: ["month", "day", "year"],
    parts: {
      day: {
        mask: "dd",
        matchers: [yt],
        preMatchHook: pt
      },
      month: {
        mask: "mm",
        matchers: [Gt],
        preMatchHook: Jt
      },
      year: {
        mask: "yyyy",
        matchers: [gt]
      }
    }
  };
}
function Ac({
  activeDate: t,
  getDateDisabled: e,
  keyboardKey: n,
  maxDate: r,
  minDate: s,
  shiftKeyPressed: i,
  utils: a
}) {
  return Yo({
    isAtLimit: (o) => zo(a, { maxDate: r, minDate: s }, o),
    isEnabled: (o) => !Wr(a, o, s, r, e),
    navigator: (o) => Io(a, o, n, i),
    value: t
  });
}
function Ve(t, e) {
  if (t == null) return {};
  var n = {};
  for (var r in t) if ({}.hasOwnProperty.call(t, r)) {
    if (e.includes(r)) continue;
    n[r] = t[r];
  }
  return n;
}
function x() {
  return x = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, x.apply(null, arguments);
}
function ks(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) for (e = 0; e < t.length; e++) t[e] && (n = ks(t[e])) && (r && (r += " "), r += n);
  else for (e in t) t[e] && (r && (r += " "), r += e);
  return r;
}
function ee() {
  for (var t, e, n = 0, r = ""; n < arguments.length; ) (t = arguments[n++]) && (e = ks(t)) && (r && (r += " "), r += e);
  return r;
}
function qo(t, e) {
  return Array.isArray(e) ? e.every((n) => t.indexOf(n) !== -1) : t.indexOf(e) !== -1;
}
const Go = (t, e) => (n) => {
  (n.key === "Enter" || n.key === " ") && (t(), n.preventDefault(), n.stopPropagation());
}, Jo = ["disabled", "onSelect", "selected", "value"], ir = we("PrivatePickersMonth", ["root", "selected"]), Ko = L(lr)(({
  theme: t
}) => x({
  flex: "1 0 33.33%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, t.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus, &:hover": {
    backgroundColor: Dt(t.palette.action.active, t.palette.action.hoverOpacity)
  },
  "&:disabled": {
    pointerEvents: "none",
    color: t.palette.text.secondary
  },
  [`&.${ir.selected}`]: {
    color: t.palette.primary.contrastText,
    backgroundColor: t.palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: t.palette.primary.dark
    }
  }
})), Qo = (t) => {
  const {
    disabled: e,
    onSelect: n,
    selected: r,
    value: s
  } = t, i = Ve(t, Jo), a = () => {
    n(s);
  };
  return /* @__PURE__ */ y.jsx(Ko, x({
    component: "button",
    type: "button",
    className: ee(ir.root, r && ir.selected),
    tabIndex: e ? -1 : 0,
    onClick: a,
    onKeyDown: Go(a),
    color: r ? "primary" : void 0,
    variant: r ? "h5" : "subtitle1",
    disabled: e
  }, i));
}, Xo = (t) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: x({}, t)
      }
    }
  }
}), xs = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "open previous view",
  openNextView: "open next view",
  calendarViewSwitchingButtonAriaLabel: (t) => t === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  inputModeToggleButtonAriaLabel: (t, e) => t ? `text input view is open, go to ${e} view` : `${e} view is open, go to text input view`,
  // DateRange placeholders
  start: "Start",
  end: "End",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerDefaultToolbarTitle: "Select date",
  dateTimePickerDefaultToolbarTitle: "Select date & time",
  timePickerDefaultToolbarTitle: "Select time",
  dateRangePickerDefaultToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (t, e, n) => `Select ${t}. ${e === null ? "No time selected" : `Selected time is ${n.format(e, "fullTime")}`}`,
  hoursClockNumberText: (t) => `${t} hours`,
  minutesClockNumberText: (t) => `${t} minutes`,
  secondsClockNumberText: (t) => `${t} seconds`,
  // Open picker labels
  openDatePickerDialogue: (t, e) => t && e.isValid(e.date(t)) ? `Choose date, selected date is ${e.format(e.date(t), "fullDate")}` : "Choose date",
  openTimePickerDialogue: (t, e) => t && e.isValid(e.date(t)) ? `Choose time, selected time is ${e.format(e.date(t), "fullTime")}` : "Choose time",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date"
}, eu = xs;
Xo(xs);
const Ss = /* @__PURE__ */ v.createContext(null);
function tu(t) {
  const e = ot({
    props: t,
    name: "MuiLocalizationProvider"
  }), {
    children: n,
    dateAdapter: r,
    dateFormats: s,
    dateLibInstance: i,
    locale: a,
    adapterLocale: o,
    localeText: u
  } = e, l = v.useMemo(() => new r({
    locale: o ?? a,
    formats: s,
    instance: i
  }), [r, a, o, s, i]), c = v.useMemo(() => ({
    minDate: l.date("1900-01-01T00:00:00.000"),
    maxDate: l.date("2099-12-31T00:00:00.000")
  }), [l]), h = v.useMemo(() => ({
    utils: l,
    defaultDates: c,
    localeText: x({}, eu, u ?? {})
  }), [c, l, u]);
  return /* @__PURE__ */ y.jsx(Ss.Provider, {
    value: h,
    children: n
  });
}
const Vt = () => {
  const t = v.useContext(Ss);
  if (t === null)
    throw new Error("MUI: Can not find utils in context. It looks like you forgot to wrap your component in LocalizationProvider, or pass dateAdapter prop directly.");
  return t;
}, te = () => Vt().utils, Hr = () => Vt().defaultDates, ru = () => Vt().localeText, jt = () => {
  const t = te();
  return v.useRef(t.date()).current;
};
function nu(t) {
  return at("MuiMonthPicker", t);
}
we("MuiMonthPicker", ["root"]);
const Kt = ({
  date: t,
  disableFuture: e,
  disablePast: n,
  maxDate: r,
  minDate: s,
  isDateDisabled: i,
  utils: a
}) => {
  const o = a.startOfDay(a.date());
  n && a.isBefore(s, o) && (s = o), e && a.isAfter(r, o) && (r = o);
  let u = t, l = t;
  for (a.isBefore(t, s) && (u = a.date(s), l = null), a.isAfter(t, r) && (l && (l = a.date(r)), u = null); u || l; ) {
    if (u && a.isAfter(u, r) && (u = null), l && a.isBefore(l, s) && (l = null), u) {
      if (!i(u))
        return u;
      u = a.addDays(u, 1);
    }
    if (l) {
      if (!i(l))
        return l;
      l = a.addDays(l, -1);
    }
  }
  return null;
}, Se = (t, e, n) => {
  if (e == null)
    return n;
  const r = t.date(e);
  return t.isValid(r) ? r : n;
}, su = ["className", "date", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday"], iu = (t) => {
  const {
    classes: e
  } = t;
  return it({
    root: ["root"]
  }, nu, e);
};
function au(t, e) {
  const n = te(), r = Hr(), s = ot({
    props: t,
    name: e
  });
  return x({
    disableFuture: !1,
    disablePast: !1
  }, s, {
    minDate: Se(n, s.minDate, r.minDate),
    maxDate: Se(n, s.maxDate, r.maxDate)
  });
}
const ou = L("div", {
  name: "MuiMonthPicker",
  slot: "Root",
  overridesResolver: (t, e) => e.root
})({
  width: 310,
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  margin: "0 4px"
}), uu = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const r = te(), s = jt(), i = au(e, "MuiMonthPicker"), {
    className: a,
    date: o,
    disabled: u,
    disableFuture: l,
    disablePast: c,
    maxDate: h,
    minDate: d,
    onChange: m,
    shouldDisableMonth: p,
    readOnly: w,
    disableHighlightToday: D
  } = i, S = Ve(i, su), T = i, H = iu(T), P = o ?? s, F = v.useMemo(() => o != null ? r.getMonth(o) : D ? null : r.getMonth(s), [s, o, r, D]), E = (O) => {
    const A = r.startOfMonth(c && r.isAfter(s, d) ? s : d), _ = r.startOfMonth(l && r.isBefore(s, h) ? s : h);
    return r.isBefore(O, A) || r.isAfter(O, _) ? !0 : p ? p(O) : !1;
  }, Y = (O) => {
    if (w)
      return;
    const A = r.setMonth(P, O);
    m(A, "finish");
  }, J = r.getMonth(s);
  return /* @__PURE__ */ y.jsx(ou, x({
    ref: n,
    className: ee(H.root, a),
    ownerState: T
  }, S, {
    children: r.getMonthArray(P).map((O) => {
      const A = r.getMonth(O), _ = r.format(O, "monthShort");
      return /* @__PURE__ */ y.jsx(Qo, {
        value: A,
        selected: A === F,
        onSelect: Y,
        disabled: u || E(O),
        "aria-current": J === A ? "date" : void 0,
        children: _
      }, _);
    })
  }));
}), lu = ({
  props: t,
  value: e,
  adapter: n
}) => {
  const r = n.utils.date(), s = n.utils.date(e), i = Se(n.utils, t.minDate, n.defaultDates.minDate), a = Se(n.utils, t.maxDate, n.defaultDates.maxDate);
  if (s === null)
    return null;
  switch (!0) {
    case !n.utils.isValid(e):
      return "invalidDate";
    case !!(t.shouldDisableDate && t.shouldDisableDate(s)):
      return "shouldDisableDate";
    case !!(t.disableFuture && n.utils.isAfterDay(s, r)):
      return "disableFuture";
    case !!(t.disablePast && n.utils.isBeforeDay(s, r)):
      return "disablePast";
    case !!(i && n.utils.isBeforeDay(s, i)):
      return "minDate";
    case !!(a && n.utils.isAfterDay(s, a)):
      return "maxDate";
    default:
      return null;
  }
}, Ts = ({
  shouldDisableDate: t,
  minDate: e,
  maxDate: n,
  disableFuture: r,
  disablePast: s
}) => {
  const i = Vt();
  return v.useCallback((a) => lu({
    adapter: i,
    value: a,
    props: {
      shouldDisableDate: t,
      minDate: e,
      maxDate: n,
      disableFuture: r,
      disablePast: s
    }
  }) !== null, [i, t, e, n, r, s]);
}, cu = (t, e, n) => (r, s) => {
  switch (s.type) {
    case "changeMonth":
      return x({}, r, {
        slideDirection: s.direction,
        currentMonth: s.newMonth,
        isMonthSwitchingAnimating: !t
      });
    case "finishMonthSwitchingAnimation":
      return x({}, r, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (r.focusedDay != null && s.focusedDay != null && n.isSameDay(s.focusedDay, r.focusedDay))
        return r;
      const i = s.focusedDay != null && !e && !n.isSameMonth(r.currentMonth, s.focusedDay);
      return x({}, r, {
        focusedDay: s.focusedDay,
        isMonthSwitchingAnimating: i && !t,
        currentMonth: i ? n.startOfMonth(s.focusedDay) : r.currentMonth,
        slideDirection: s.focusedDay != null && n.isAfterDay(s.focusedDay, r.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
}, du = ({
  date: t,
  defaultCalendarMonth: e,
  disableFuture: n,
  disablePast: r,
  disableSwitchToMonthOnDayFocus: s = !1,
  maxDate: i,
  minDate: a,
  onMonthChange: o,
  reduceAnimations: u,
  shouldDisableDate: l
}) => {
  var c;
  const h = jt(), d = te(), m = v.useRef(cu(!!u, s, d)).current, [p, w] = v.useReducer(m, {
    isMonthSwitchingAnimating: !1,
    focusedDay: t || h,
    currentMonth: d.startOfMonth((c = t ?? e) != null ? c : h),
    slideDirection: "left"
  }), D = v.useCallback((F) => {
    w(x({
      type: "changeMonth"
    }, F)), o && o(F.newMonth);
  }, [o]), S = v.useCallback((F) => {
    const E = F ?? h;
    d.isSameMonth(E, p.currentMonth) || D({
      newMonth: d.startOfMonth(E),
      direction: d.isAfterDay(E, p.currentMonth) ? "left" : "right"
    });
  }, [p.currentMonth, D, h, d]), T = Ts({
    shouldDisableDate: l,
    minDate: a,
    maxDate: i,
    disableFuture: n,
    disablePast: r
  }), H = v.useCallback(() => {
    w({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), P = v.useCallback((F) => {
    T(F) || w({
      type: "changeFocusedDay",
      focusedDay: F
    });
  }, [T]);
  return {
    calendarState: p,
    changeMonth: S,
    changeFocusedDay: P,
    isDateDisabled: T,
    onMonthSwitchingAnimationEnd: H,
    handleChangeMonth: D
  };
}, fu = we("PrivatePickersFadeTransitionGroup", ["root"]), bn = 500, hu = L(xn)({
  display: "block",
  position: "relative"
}), Os = ({
  children: t,
  className: e,
  reduceAnimations: n,
  transKey: r
}) => n ? t : /* @__PURE__ */ y.jsx(hu, {
  className: ee(fu.root, e),
  children: /* @__PURE__ */ y.jsx(Sn, {
    appear: !1,
    mountOnEnter: !0,
    unmountOnExit: !0,
    timeout: {
      appear: bn,
      enter: bn / 2,
      exit: 0
    },
    children: t
  }, r)
}), mu = typeof window < "u" ? v.useLayoutEffect : v.useEffect, ar = 36, Yr = 2, yu = 320, gu = 358;
function pu(t) {
  return at("MuiPickersDay", t);
}
const wt = we("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]), wu = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDayFocus", "onDaySelect", "onFocus", "onKeyDown", "onMouseDown", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today"], bu = (t) => {
  const {
    selected: e,
    disableMargin: n,
    disableHighlightToday: r,
    today: s,
    outsideCurrentMonth: i,
    showDaysOutsideCurrentMonth: a,
    classes: o
  } = t;
  return it({
    root: ["root", e && "selected", !n && "dayWithMargin", !r && s && "today", i && a && "dayOutsideMonth"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, pu, o);
}, Cs = ({
  theme: t,
  ownerState: e
}) => x({}, t.typography.caption, {
  width: ar,
  height: ar,
  borderRadius: "50%",
  padding: 0,
  // background required here to prevent collides with the other days when animating with transition group
  backgroundColor: t.palette.background.paper,
  color: t.palette.text.primary,
  "&:hover": {
    backgroundColor: Dt(t.palette.action.active, t.palette.action.hoverOpacity)
  },
  "&:focus": {
    backgroundColor: Dt(t.palette.action.active, t.palette.action.hoverOpacity),
    [`&.${wt.selected}`]: {
      willChange: "background-color",
      backgroundColor: t.palette.primary.dark
    }
  },
  [`&.${wt.selected}`]: {
    color: t.palette.primary.contrastText,
    backgroundColor: t.palette.primary.main,
    fontWeight: t.typography.fontWeightMedium,
    transition: t.transitions.create("background-color", {
      duration: t.transitions.duration.short
    }),
    "&:hover": {
      willChange: "background-color",
      backgroundColor: t.palette.primary.dark
    }
  },
  [`&.${wt.disabled}`]: {
    color: t.palette.text.disabled
  }
}, !e.disableMargin && {
  margin: `0 ${Yr}px`
}, e.outsideCurrentMonth && e.showDaysOutsideCurrentMonth && {
  color: t.palette.text.secondary
}, !e.disableHighlightToday && e.today && {
  [`&:not(.${wt.selected})`]: {
    border: `1px solid ${t.palette.text.secondary}`
  }
}), Es = (t, e) => {
  const {
    ownerState: n
  } = t;
  return [e.root, !n.disableMargin && e.dayWithMargin, !n.disableHighlightToday && n.today && e.today, !n.outsideCurrentMonth && n.showDaysOutsideCurrentMonth && e.dayOutsideMonth, n.outsideCurrentMonth && !n.showDaysOutsideCurrentMonth && e.hiddenDaySpacingFiller];
}, vu = L(Zs, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: Es
})(Cs), Mu = L("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: Es
})(({
  theme: t,
  ownerState: e
}) => x({}, Cs({
  theme: t,
  ownerState: e
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0
})), Du = () => {
}, ku = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const r = ot({
    props: e,
    name: "MuiPickersDay"
  }), {
    autoFocus: s = !1,
    className: i,
    day: a,
    disabled: o = !1,
    disableHighlightToday: u = !1,
    disableMargin: l = !1,
    isAnimating: c,
    onClick: h,
    onDayFocus: d = Du,
    onDaySelect: m,
    onFocus: p,
    onKeyDown: w,
    onMouseDown: D,
    outsideCurrentMonth: S,
    selected: T = !1,
    showDaysOutsideCurrentMonth: H = !1,
    children: P,
    today: F = !1
  } = r, E = Ve(r, wu), Y = x({}, r, {
    autoFocus: s,
    disabled: o,
    disableHighlightToday: u,
    disableMargin: l,
    selected: T,
    showDaysOutsideCurrentMonth: H,
    today: F
  }), J = bu(Y), O = te(), A = v.useRef(null), _ = On(A, n);
  mu(() => {
    s && !o && !c && !S && A.current.focus();
  }, [s, o, c, S]);
  const le = (M) => {
    d && d(a), p && p(M);
  }, Z = (M) => {
    D && D(M), S && M.preventDefault();
  }, re = (M) => {
    o || m(a, "finish"), S && M.currentTarget.focus(), h && h(M);
  }, ne = ur();
  function ge(M) {
    switch (w !== void 0 && w(M), M.key) {
      case "ArrowUp":
        d(O.addDays(a, -7)), M.preventDefault();
        break;
      case "ArrowDown":
        d(O.addDays(a, 7)), M.preventDefault();
        break;
      case "ArrowLeft":
        d(O.addDays(a, ne.direction === "ltr" ? -1 : 1)), M.preventDefault();
        break;
      case "ArrowRight":
        d(O.addDays(a, ne.direction === "ltr" ? 1 : -1)), M.preventDefault();
        break;
      case "Home":
        d(O.startOfWeek(a)), M.preventDefault();
        break;
      case "End":
        d(O.endOfWeek(a)), M.preventDefault();
        break;
      case "PageUp":
        d(O.getNextMonth(a)), M.preventDefault();
        break;
      case "PageDown":
        d(O.getPreviousMonth(a)), M.preventDefault();
        break;
    }
  }
  return S && !H ? /* @__PURE__ */ y.jsx(Mu, {
    className: ee(J.root, J.hiddenDaySpacingFiller, i),
    ownerState: Y,
    role: E.role
  }) : /* @__PURE__ */ y.jsx(vu, x({
    className: ee(J.root, i),
    ownerState: Y,
    ref: _,
    centerRipple: !0,
    disabled: o,
    tabIndex: T ? 0 : -1,
    onFocus: le,
    onKeyDown: ge,
    onClick: re,
    onMouseDown: Z
  }, E, {
    children: P || O.format(a, "dayOfMonth")
  }));
}), xu = (t, e) => t.autoFocus === e.autoFocus && t.isAnimating === e.isAnimating && t.today === e.today && t.disabled === e.disabled && t.selected === e.selected && t.disableMargin === e.disableMargin && t.showDaysOutsideCurrentMonth === e.showDaysOutsideCurrentMonth && t.disableHighlightToday === e.disableHighlightToday && t.className === e.className && t.outsideCurrentMonth === e.outsideCurrentMonth && t.onDayFocus === e.onDayFocus && t.onDaySelect === e.onDaySelect, Ns = /* @__PURE__ */ v.memo(ku, xu), Su = ["children", "className", "reduceAnimations", "slideDirection", "transKey"], ae = we("PrivatePickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), Fs = 350, Tu = L(xn)(({
  theme: t
}) => {
  const e = t.transitions.create("transform", {
    duration: Fs,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${ae["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${ae["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${ae.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: e
    },
    [`& .${ae.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${ae["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: e,
      zIndex: 0
    },
    [`& .${ae["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: e,
      zIndex: 0
    }
  };
}), Ou = (t) => {
  let {
    children: e,
    className: n,
    reduceAnimations: r,
    slideDirection: s,
    transKey: i
  } = t, a = Ve(t, Su);
  if (r)
    return /* @__PURE__ */ y.jsx("div", {
      className: ee(ae.root, n),
      children: e
    });
  const o = {
    exit: ae.slideExit,
    enterActive: ae.slideEnterActive,
    enter: ae[`slideEnter-${s}`],
    exitActive: ae[`slideExitActiveLeft-${s}`]
  };
  return /* @__PURE__ */ y.jsx(Tu, {
    className: ee(ae.root, n),
    childFactory: (u) => /* @__PURE__ */ v.cloneElement(u, {
      classNames: o
    }),
    role: "presentation",
    children: /* @__PURE__ */ y.jsx(cr, x({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: Fs,
      classNames: o
    }, a, {
      children: e
    }), i)
  });
}, Cu = (t) => t.charAt(0).toUpperCase(), As = (ar + Yr * 2) * 6, Eu = L("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), Nu = L(lr)(({
  theme: t
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: t.palette.text.secondary
})), Fu = L("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: As
}), Au = L(Ou)({
  minHeight: As
}), Iu = L("div")({
  overflow: "hidden"
}), Lu = L("div")({
  margin: `${Yr}px 0`,
  display: "flex",
  justifyContent: "center"
});
function Pu(t) {
  const e = jt(), n = te(), {
    autoFocus: r,
    onFocusedDayChange: s,
    className: i,
    currentMonth: a,
    selectedDays: o,
    disabled: u,
    disableHighlightToday: l,
    focusedDay: c,
    isMonthSwitchingAnimating: h,
    loading: d,
    onSelectedDaysChange: m,
    onMonthSwitchingAnimationEnd: p,
    readOnly: w,
    reduceAnimations: D,
    renderDay: S,
    renderLoading: T = () => /* @__PURE__ */ y.jsx("span", {
      children: "..."
    }),
    showDaysOutsideCurrentMonth: H,
    slideDirection: P,
    TransitionProps: F,
    disablePast: E,
    disableFuture: Y,
    minDate: J,
    maxDate: O,
    shouldDisableDate: A,
    dayOfWeekFormatter: _ = Cu,
    gridLabelId: le
  } = t, Z = Ts({
    shouldDisableDate: A,
    minDate: J,
    maxDate: O,
    disablePast: E,
    disableFuture: Y
  }), re = v.useCallback((R, G = "finish") => {
    w || m(R, G);
  }, [m, w]), ne = n.getMonth(a), ge = o.filter((R) => !!R).map((R) => n.startOfDay(R)), M = ne, B = v.useMemo(() => /* @__PURE__ */ v.createRef(), [M]), be = n.startOfWeek(e);
  return /* @__PURE__ */ y.jsxs("div", {
    role: "grid",
    "aria-labelledby": le,
    children: [/* @__PURE__ */ y.jsx(Eu, {
      role: "row",
      children: n.getWeekdays().map((R, G) => {
        var Oe;
        return /* @__PURE__ */ y.jsx(Nu, {
          variant: "caption",
          role: "columnheader",
          "aria-label": n.format(n.addDays(be, G), "weekday"),
          children: (Oe = _ == null ? void 0 : _(R)) != null ? Oe : R
        }, R + G.toString());
      })
    }), d ? /* @__PURE__ */ y.jsx(Fu, {
      children: T()
    }) : /* @__PURE__ */ y.jsx(Au, x({
      transKey: M,
      onExited: p,
      reduceAnimations: D,
      slideDirection: P,
      className: i
    }, F, {
      nodeRef: B,
      children: /* @__PURE__ */ y.jsx(Iu, {
        ref: B,
        role: "rowgroup",
        children: n.getWeekArray(a).map((R) => /* @__PURE__ */ y.jsx(Lu, {
          role: "row",
          children: R.map((G) => {
            const Oe = ge.some((Je) => n.isSameDay(Je, G)), dt = n.isSameDay(G, e), je = {
              key: G == null ? void 0 : G.toString(),
              day: G,
              isAnimating: h,
              disabled: u || Z(G),
              autoFocus: r && c !== null && n.isSameDay(G, c),
              today: dt,
              outsideCurrentMonth: n.getMonth(G) !== ne,
              selected: Oe,
              disableHighlightToday: l,
              showDaysOutsideCurrentMonth: H,
              onDayFocus: s,
              onDaySelect: re,
              role: "gridcell",
              "aria-selected": Oe
            };
            return dt && (je["aria-current"] = "date"), S ? S(G, ge, je) : /* @__PURE__ */ y.jsx(Ns, x({}, je), je.key);
          })
        }, `week-${R[0]}`))
      })
    }))]
  });
}
function Ru({
  onChange: t,
  onViewChange: e,
  openTo: n,
  view: r,
  views: s
}) {
  var i, a;
  const [o, u] = Js({
    name: "Picker",
    state: "view",
    controlled: r,
    default: n && qo(s, n) ? n : s[0]
  }), l = (i = s[s.indexOf(o) - 1]) != null ? i : null, c = (a = s[s.indexOf(o) + 1]) != null ? a : null, h = v.useCallback((p) => {
    u(p), e && e(p);
  }, [u, e]), d = v.useCallback(() => {
    c && h(c);
  }, [c, h]);
  return {
    handleChangeAndOpenNext: v.useCallback((p, w) => {
      const D = w === "finish";
      t(p, D && c ? "partial" : w), D && d();
    }, [c, t, d]),
    nextView: c,
    previousView: l,
    openNext: d,
    openView: o,
    setOpenView: h
  };
}
const Vu = Te(/* @__PURE__ */ y.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), ju = Te(/* @__PURE__ */ y.jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), $u = Te(/* @__PURE__ */ y.jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight");
Te(/* @__PURE__ */ y.jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
Te(/* @__PURE__ */ y.jsxs(v.Fragment, {
  children: [/* @__PURE__ */ y.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ y.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock");
Te(/* @__PURE__ */ y.jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
Te(/* @__PURE__ */ y.jsx("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), "Pen");
Te(/* @__PURE__ */ y.jsxs(v.Fragment, {
  children: [/* @__PURE__ */ y.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ y.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time");
const Wu = ["children", "className", "components", "componentsProps", "isLeftDisabled", "isLeftHidden", "isRightDisabled", "isRightHidden", "leftArrowButtonText", "onLeftClick", "onRightClick", "rightArrowButtonText"], bt = we("MuiPickersArrowSwitcher", ["root", "spacer", "button"]), Hu = L("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (t, e) => e.root
})({
  display: "flex"
}), Yu = L("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (t, e) => e.spacer
})(({
  theme: t
}) => ({
  width: t.spacing(3)
})), vn = L(Tn, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (t, e) => e.button
})(({
  ownerState: t
}) => x({}, t.hidden && {
  visibility: "hidden"
})), zu = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    children: r,
    className: s,
    components: i,
    componentsProps: a,
    isLeftDisabled: o,
    isLeftHidden: u,
    isRightDisabled: l,
    isRightHidden: c,
    leftArrowButtonText: h,
    onLeftClick: d,
    onRightClick: m,
    rightArrowButtonText: p
  } = e, w = Ve(e, Wu), S = ur().direction === "rtl", T = (a == null ? void 0 : a.leftArrowButton) || {}, H = (i == null ? void 0 : i.LeftArrowIcon) || ju, P = (a == null ? void 0 : a.rightArrowButton) || {}, F = (i == null ? void 0 : i.RightArrowIcon) || $u, E = e;
  return /* @__PURE__ */ y.jsxs(Hu, x({
    ref: n,
    className: ee(bt.root, s),
    ownerState: E
  }, w, {
    children: [/* @__PURE__ */ y.jsx(vn, x({
      as: i == null ? void 0 : i.LeftArrowButton,
      size: "small",
      "aria-label": h,
      title: h,
      disabled: o,
      edge: "end",
      onClick: d
    }, T, {
      className: ee(bt.button, T.className),
      ownerState: x({}, E, T, {
        hidden: u
      }),
      children: S ? /* @__PURE__ */ y.jsx(F, {}) : /* @__PURE__ */ y.jsx(H, {})
    })), r ? /* @__PURE__ */ y.jsx(lr, {
      variant: "subtitle1",
      component: "span",
      children: r
    }) : /* @__PURE__ */ y.jsx(Yu, {
      className: bt.spacer,
      ownerState: E
    }), /* @__PURE__ */ y.jsx(vn, x({
      as: i == null ? void 0 : i.RightArrowButton,
      size: "small",
      "aria-label": p,
      title: p,
      edge: "start",
      disabled: l,
      onClick: m
    }, P, {
      className: ee(bt.button, P.className),
      ownerState: x({}, E, P, {
        hidden: c
      }),
      children: S ? /* @__PURE__ */ y.jsx(H, {}) : /* @__PURE__ */ y.jsx(F, {})
    }))]
  }));
});
function Bu(t, {
  disableFuture: e,
  maxDate: n
}) {
  const r = te();
  return v.useMemo(() => {
    const s = r.date(), i = r.startOfMonth(e && r.isBefore(s, n) ? s : n);
    return !r.isAfter(i, t);
  }, [e, n, t, r]);
}
function Zu(t, {
  disablePast: e,
  minDate: n
}) {
  const r = te();
  return v.useMemo(() => {
    const s = r.date(), i = r.startOfMonth(e && r.isAfter(s, n) ? s : n);
    return !r.isBefore(i, t);
  }, [e, n, t, r]);
}
const Uu = (t) => () => {
}, _u = L("div")({
  display: "flex",
  alignItems: "center",
  marginTop: 16,
  marginBottom: 8,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 30,
  minHeight: 30
}), qu = L("div")(({
  theme: t
}) => x({
  display: "flex",
  maxHeight: 30,
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, t.typography.body1, {
  fontWeight: t.typography.fontWeightMedium
})), Gu = L("div")({
  marginRight: 6
}), Ju = L(Tn)({
  marginRight: "auto"
}), Ku = L(Vu)(({
  theme: t,
  ownerState: e
}) => x({
  willChange: "transform",
  transition: t.transitions.create("transform"),
  transform: "rotate(0deg)"
}, e.openView === "year" && {
  transform: "rotate(180deg)"
})), Qu = Uu();
function Xu(t) {
  const {
    components: e = {},
    componentsProps: n = {},
    currentMonth: r,
    disabled: s,
    disableFuture: i,
    disablePast: a,
    getViewSwitchingButtonText: o,
    leftArrowButtonText: u,
    maxDate: l,
    minDate: c,
    onMonthChange: h,
    onViewChange: d,
    openView: m,
    reduceAnimations: p,
    rightArrowButtonText: w,
    views: D,
    labelId: S
  } = t;
  Qu({
    leftArrowButtonText: u,
    rightArrowButtonText: w,
    getViewSwitchingButtonText: o
  });
  const T = ru(), H = u ?? T.previousMonth, P = w ?? T.nextMonth, F = o ?? T.calendarViewSwitchingButtonAriaLabel, E = te(), Y = n.switchViewButton || {}, J = () => h(E.getNextMonth(r), "left"), O = () => h(E.getPreviousMonth(r), "right"), A = Bu(r, {
    disableFuture: i,
    maxDate: l
  }), _ = Zu(r, {
    disablePast: a,
    minDate: c
  }), le = () => {
    if (!(D.length === 1 || !d || s))
      if (D.length === 2)
        d(D.find((re) => re !== m) || D[0]);
      else {
        const re = D.indexOf(m) !== 0 ? 0 : 1;
        d(D[re]);
      }
  };
  if (D.length === 1 && D[0] === "year")
    return null;
  const Z = t;
  return /* @__PURE__ */ y.jsxs(_u, {
    ownerState: Z,
    children: [/* @__PURE__ */ y.jsxs(qu, {
      role: "presentation",
      onClick: le,
      ownerState: Z,
      "aria-live": "polite",
      children: [/* @__PURE__ */ y.jsx(Os, {
        reduceAnimations: p,
        transKey: E.format(r, "monthAndYear"),
        children: /* @__PURE__ */ y.jsx(Gu, {
          id: S,
          ownerState: Z,
          children: E.format(r, "monthAndYear")
        })
      }), D.length > 1 && !s && /* @__PURE__ */ y.jsx(Ju, x({
        size: "small",
        as: e.SwitchViewButton,
        "aria-label": F(m)
      }, Y, {
        children: /* @__PURE__ */ y.jsx(Ku, {
          as: e.SwitchViewIcon,
          ownerState: Z
        })
      }))]
    }), /* @__PURE__ */ y.jsx(Sn, {
      in: m === "day",
      children: /* @__PURE__ */ y.jsx(zu, {
        leftArrowButtonText: H,
        rightArrowButtonText: P,
        components: e,
        componentsProps: n,
        onLeftClick: O,
        onRightClick: J,
        isLeftDisabled: _,
        isRightDisabled: A
      })
    })]
  });
}
const Is = /* @__PURE__ */ v.createContext(null), el = ["autoFocus", "className", "children", "disabled", "onClick", "onKeyDown", "selected", "value"];
function tl(t) {
  return at("PrivatePickersYear", t);
}
const Mn = we("PrivatePickersYear", ["root", "modeMobile", "modeDesktop", "yearButton", "disabled", "selected"]), rl = (t) => {
  const {
    wrapperVariant: e,
    disabled: n,
    selected: r,
    classes: s
  } = t, i = {
    root: ["root", e && `mode${Hs(e)}`],
    yearButton: ["yearButton", n && "disabled", r && "selected"]
  };
  return it(i, tl, s);
}, nl = L("div")(({
  ownerState: t
}) => x({
  flexBasis: "33.3%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, (t == null ? void 0 : t.wrapperVariant) === "desktop" && {
  flexBasis: "25%"
})), sl = L("button")(({
  theme: t
}) => x({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, t.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus, &:hover": {
    backgroundColor: Dt(t.palette.action.active, t.palette.action.hoverOpacity)
  },
  [`&.${Mn.disabled}`]: {
    color: t.palette.text.secondary
  },
  [`&.${Mn.selected}`]: {
    color: t.palette.primary.contrastText,
    backgroundColor: t.palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: t.palette.primary.dark
    }
  }
})), il = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    autoFocus: r,
    className: s,
    children: i,
    disabled: a,
    onClick: o,
    onKeyDown: u,
    selected: l,
    value: c
  } = e, h = Ve(e, el), d = v.useRef(null), m = On(d, n), p = v.useContext(Is), w = x({}, e, {
    wrapperVariant: p
  }), D = rl(w);
  return v.useEffect(() => {
    r && d.current.focus();
  }, [r]), /* @__PURE__ */ y.jsx(nl, {
    className: ee(D.root, s),
    ownerState: w,
    children: /* @__PURE__ */ y.jsx(sl, x({
      ref: m,
      disabled: a,
      type: "button",
      tabIndex: l ? 0 : -1,
      onClick: (S) => o(S, c),
      onKeyDown: (S) => u(S, c),
      className: D.yearButton,
      ownerState: w
    }, h, {
      children: i
    }))
  });
});
function al(t) {
  return at("MuiYearPicker", t);
}
we("MuiYearPicker", ["root"]);
const ol = (t) => {
  const {
    classes: e
  } = t;
  return it({
    root: ["root"]
  }, al, e);
};
function ul(t, e) {
  const n = te(), r = Hr(), s = ot({
    props: t,
    name: e
  });
  return x({
    disablePast: !1,
    disableFuture: !1
  }, s, {
    minDate: Se(n, s.minDate, r.minDate),
    maxDate: Se(n, s.maxDate, r.maxDate)
  });
}
const ll = L("div", {
  name: "MuiYearPicker",
  slot: "Root",
  overridesResolver: (t, e) => e.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  margin: "0 4px"
}), cl = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const r = jt(), s = ur(), i = te(), a = ul(e, "MuiYearPicker"), {
    autoFocus: o,
    className: u,
    date: l,
    disabled: c,
    disableFuture: h,
    disablePast: d,
    maxDate: m,
    minDate: p,
    onChange: w,
    readOnly: D,
    shouldDisableYear: S,
    disableHighlightToday: T
  } = a, H = a, P = ol(H), F = l ?? r, E = v.useMemo(() => l != null ? i.getYear(l) : T ? null : i.getYear(r), [r, l, i, T]), Y = v.useContext(Is), J = v.useRef(null), [O, A] = v.useState(E), _ = v.useCallback((M) => !!(d && i.isBeforeYear(M, r) || h && i.isAfterYear(M, r) || p && i.isBeforeYear(M, p) || m && i.isAfterYear(M, m) || S && S(M)), [h, d, m, p, r, S, i]), le = (M, B, be = "finish") => {
    if (D)
      return;
    const R = i.setYear(F, B);
    w(R, be);
  }, Z = v.useCallback((M) => {
    _(i.setYear(F, M)) || A(M);
  }, [F, _, i]), re = Y === "desktop" ? 4 : 3, ne = (M, B) => {
    switch (M.key) {
      case "ArrowUp":
        Z(B - re), M.preventDefault();
        break;
      case "ArrowDown":
        Z(B + re), M.preventDefault();
        break;
      case "ArrowLeft":
        Z(B + (s.direction === "ltr" ? -1 : 1)), M.preventDefault();
        break;
      case "ArrowRight":
        Z(B + (s.direction === "ltr" ? 1 : -1)), M.preventDefault();
        break;
    }
  }, ge = i.getYear(r);
  return /* @__PURE__ */ y.jsx(ll, {
    ref: n,
    className: ee(P.root, u),
    ownerState: H,
    children: i.getYearRange(p, m).map((M) => {
      const B = i.getYear(M), be = B === E;
      return /* @__PURE__ */ y.jsx(il, {
        selected: be,
        value: B,
        onClick: le,
        onKeyDown: ne,
        autoFocus: o && B === O,
        ref: be ? J : void 0,
        disabled: c || _(M),
        "aria-current": ge === B ? "date" : void 0,
        children: i.format(M, "year")
      }, i.format(M, "year"));
    })
  });
}), dl = L("div")({
  overflowX: "hidden",
  width: yu,
  maxHeight: gu,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
}), fl = typeof navigator < "u" && /(android)/i.test(navigator.userAgent), hl = (t) => at("MuiCalendarPicker", t);
we("MuiCalendarPicker", ["root", "viewTransitionContainer"]);
const ml = ["autoFocus", "onViewChange", "date", "disableFuture", "disablePast", "defaultCalendarMonth", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday"], yl = (t) => {
  const {
    classes: e
  } = t;
  return it({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, hl, e);
};
function gl(t, e) {
  const n = te(), r = Hr(), s = ot({
    props: t,
    name: e
  });
  return x({
    loading: !1,
    disablePast: !1,
    disableFuture: !1,
    openTo: "day",
    views: ["year", "day"],
    reduceAnimations: fl,
    renderLoading: () => /* @__PURE__ */ y.jsx("span", {
      children: "..."
    })
  }, s, {
    minDate: Se(n, s.minDate, r.minDate),
    maxDate: Se(n, s.maxDate, r.maxDate)
  });
}
const pl = L(dl, {
  name: "MuiCalendarPicker",
  slot: "Root",
  overridesResolver: (t, e) => e.root
})({
  display: "flex",
  flexDirection: "column"
}), wl = L(Os, {
  name: "MuiCalendarPicker",
  slot: "ViewTransitionContainer",
  overridesResolver: (t, e) => e.viewTransitionContainer
})({
  overflowY: "auto"
}), bl = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const r = te(), s = Ks(), i = gl(e, "MuiCalendarPicker"), {
    autoFocus: a,
    onViewChange: o,
    date: u,
    disableFuture: l,
    disablePast: c,
    defaultCalendarMonth: h,
    onChange: d,
    onYearChange: m,
    onMonthChange: p,
    reduceAnimations: w,
    shouldDisableDate: D,
    shouldDisableMonth: S,
    shouldDisableYear: T,
    view: H,
    views: P,
    openTo: F,
    className: E,
    disabled: Y,
    readOnly: J,
    minDate: O,
    maxDate: A,
    disableHighlightToday: _
  } = i, le = Ve(i, ml), {
    openView: Z,
    setOpenView: re,
    openNext: ne
  } = Ru({
    view: H,
    views: P,
    openTo: F,
    onChange: d,
    onViewChange: o
  }), {
    calendarState: ge,
    changeFocusedDay: M,
    changeMonth: B,
    handleChangeMonth: be,
    isDateDisabled: R,
    onMonthSwitchingAnimationEnd: G
  } = du({
    date: u,
    defaultCalendarMonth: h,
    reduceAnimations: w,
    onMonthChange: p,
    minDate: O,
    maxDate: A,
    shouldDisableDate: D,
    disablePast: c,
    disableFuture: l
  }), Oe = v.useCallback((U, ve) => {
    const Me = r.startOfMonth(U), Ke = r.endOfMonth(U), De = R(U) ? Kt({
      utils: r,
      date: U,
      minDate: r.isBefore(O, Me) ? Me : O,
      maxDate: r.isAfter(A, Ke) ? Ke : A,
      disablePast: c,
      disableFuture: l,
      isDateDisabled: R
    }) : U;
    De ? (d(De, ve), p == null || p(Me)) : (ne(), B(Me)), M(De);
  }, [M, l, c, R, A, O, d, p, B, ne, r]), dt = v.useCallback((U, ve) => {
    const Me = r.startOfYear(U), Ke = r.endOfYear(U), De = R(U) ? Kt({
      utils: r,
      date: U,
      minDate: r.isBefore(O, Me) ? Me : O,
      maxDate: r.isAfter(A, Ke) ? Ke : A,
      disablePast: c,
      disableFuture: l,
      isDateDisabled: R
    }) : U;
    De ? (d(De, ve), m == null || m(De)) : (ne(), B(Me)), M(De);
  }, [M, l, c, R, A, O, d, m, ne, r, B]), je = v.useCallback((U, ve) => d(u && U ? r.mergeDateAndTime(U, u) : U, ve), [r, u, d]);
  v.useEffect(() => {
    if (u && R(u)) {
      const U = Kt({
        utils: r,
        date: u,
        minDate: O,
        maxDate: A,
        disablePast: c,
        disableFuture: l,
        isDateDisabled: R
      });
      d(U, "partial");
    }
  }, []), v.useEffect(() => {
    u && B(u);
  }, [u]);
  const Je = i, zr = yl(Je), $t = {
    disablePast: c,
    disableFuture: l,
    maxDate: A,
    minDate: O
  }, Ls = Y && u || O, Ps = Y && u || A, Wt = {
    disableHighlightToday: _,
    readOnly: J,
    disabled: Y
  }, Br = `${s}-grid-label`;
  return /* @__PURE__ */ y.jsxs(pl, {
    ref: n,
    className: ee(zr.root, E),
    ownerState: Je,
    children: [/* @__PURE__ */ y.jsx(Xu, x({}, le, {
      views: P,
      openView: Z,
      currentMonth: ge.currentMonth,
      onViewChange: re,
      onMonthChange: (U, ve) => be({
        newMonth: U,
        direction: ve
      }),
      minDate: Ls,
      maxDate: Ps,
      disabled: Y,
      disablePast: c,
      disableFuture: l,
      reduceAnimations: w,
      labelId: Br
    })), /* @__PURE__ */ y.jsx(wl, {
      reduceAnimations: w,
      className: zr.viewTransitionContainer,
      transKey: Z,
      ownerState: Je,
      children: /* @__PURE__ */ y.jsxs("div", {
        children: [Z === "year" && /* @__PURE__ */ y.jsx(cl, x({}, le, $t, Wt, {
          autoFocus: a,
          date: u,
          onChange: dt,
          shouldDisableYear: T
        })), Z === "month" && /* @__PURE__ */ y.jsx(uu, x({}, $t, Wt, {
          className: E,
          date: u,
          onChange: Oe,
          shouldDisableMonth: S
        })), Z === "day" && /* @__PURE__ */ y.jsx(Pu, x({}, le, ge, $t, Wt, {
          autoFocus: a,
          onMonthSwitchingAnimationEnd: G,
          onFocusedDayChange: M,
          reduceAnimations: w,
          selectedDays: [u],
          onSelectedDaysChange: je,
          shouldDisableDate: D,
          gridLabelId: Br
        }))]
      })
    })]
  });
}), vl = It()((t, e) => {
  const { weeks: n } = e, { constructs: r, mode: s, spacing: i, palette: a } = t;
  return {
    root: {
      // @startCleanup encore
      width: f.ifFeature("encore", void 0, 306),
      // @endCleanup encore
      margin: f.ifFeature("encore", 0, "-3px auto 0"),
      // The days in the calendar have specific sizes and this class allows the height to adjust and animate when the month transistions to a month with less or more weeks
      maxHeight: f.ifFeature("encore", n * 43 + 79, n * 36 + 30),
      transition: "max-height .3s",
      "&:focus-within": {
        ".Mui-active": {
          boxShadow: f.ifFeature("encore", `0px 0px 0px 2px ${r.surface.primary.weak}`),
          "&.Mui-error": {
            boxShadow: f.ifFeature("encore", `0px 0px 0px 2px ${r.surface.error.weak}`)
          }
        }
      },
      "& > div:first-of-type": {
        display: "none"
      },
      "& > .MuiCalendarPicker-viewTransitionContainer > div > div > div:first-of-type": {
        // the container for the week letters is inaccessible via a class tag without modifiying a larger piece of the datepicker
        // this drill down allows for the flex of the week letters to match the spacing applied to the actual days in the grid below it
        justifyContent: f.ifFeature("encore", "space-evenly"),
        padding: f.ifFeature("encore", i(1.5, 1, 0, 1)),
        marginBottom: f.ifFeature("encore", i(1))
      },
      "& .MuiCalendarPicker-viewTransitionContainer .MuiTypography-root": {
        // @startCleanup encore
        marginBottom: f.ifFeature("encore", void 0, i(0.5)),
        // @endCleanup encore
        color: f.ifFeature("encore", r.text.neutral.weak, a.gray[600]),
        fontFamily: f.ifFeature("encore", "Inter, sans-serif"),
        fontSize: f.ifFeature("encore", "13px"),
        fontWeight: f.ifFeature("encore", 600),
        // weekday labels
        height: i(3.5)
      },
      "& .MuiCalendarPicker-viewTransitionContainer": {
        // weekday and days container
        overflow: "hidden"
      },
      "& .PrivatePickersSlideTransition-root": {
        // days container
        backgroundColor: s === Ys.Dye ? zs.main : a.common.white,
        display: f.ifFeature("encore", "flex"),
        flexDirection: f.ifFeature("encore", "column"),
        minHeight: f.ifFeature("encore", n * 46, 214),
        transition: f.ifFeature("encore", "min-height .3s"),
        "&>div:first-of-type": {
          flex: f.ifFeature("encore", 1),
          // The border applied to the right calendar on datepicker ranges requires the full height when the left calendar is bigger (due to more weeks)
          // This allows the border to adjust to the spacing and prevent touching the edge of the calenda
          height: f.ifFeature("encore", `calc(100% - ${i(1.5)})`),
          margin: f.ifFeature("encore", i(1, 0.75, 0, 0)),
          paddingLeft: f.ifFeature("encore", i(0.75)),
          // @startCleanup encore
          paddingTop: f.ifFeature("encore", void 0, 4)
          // @endCleanup encore
        },
        "[role=row]": {
          "&:first-of-type": {
            // This removes top padding from the first row to allow the row to remain flush with the border rules on Datepicker ranges
            paddingTop: f.ifFeature("encore", 0)
          },
          justifyContent: f.ifFeature("encore", "space-evenly"),
          margin: f.ifFeature("encore", 0),
          padding: f.ifFeature("encore", "2px 0")
        }
      }
    }
  };
}), Ic = ({ componentsProps: t, weeksToShow: e, components: n, ...r }) => {
  const { classes: s } = vl({ weeks: e });
  return /* @__PURE__ */ y.jsx(
    bl,
    {
      ...r,
      className: s.root,
      components: {
        LeftArrowButton: () => null,
        RightArrowButton: () => null,
        SwitchViewButton: () => null
      }
    }
  );
}, Ml = It()((t) => {
  var o;
  const { spacing: e, borderRadiuses: n, palette: r, typography: s, mixins: i, constructs: a } = t;
  return {
    root: {
      height: f.ifFeature("encore", e(5), e(4)),
      width: e(5),
      borderRadius: f.ifFeature("encore", n[300], 2),
      margin: 0,
      // @startCleanup encore
      color: f.ifFeature("encore", void 0, r.text.primary),
      // @endCleanup encore
      backgroundColor: "transparent",
      boxSizing: "border-box",
      // @startCleanup encore
      fontSize: f.ifFeature("encore", void 0, (o = s.medium) == null ? void 0 : o.fontSize),
      // @endCleanup encore
      fontWeight: f.ifFeature("encore", 500),
      "&.MuiPickersDay-today": {
        border: f.ifFeature("encore", i.border(1, a.border.neutral.weak), i.border(1, r.gray[400])),
        fontWeight: f.ifFeature("encore", 600),
        "&:hover": {
          border: f.ifFeature("encore", "none")
        },
        "&.Mui-error": {
          borderColor: f.ifFeature("encore", a.border.error.medium),
          color: f.ifFeature("encore", a.text.error.medium)
        },
        "&.Mui-disabled": {
          borderColor: f.ifFeature("encore", a.border.neutral.medium),
          color: f.ifFeature("encore", a.text.neutral.weak),
          "&.Mui-selected.Mui-error": {
            color: f.ifFeature("encore", a.text.neutral.weak, r.gray[500]),
            background: f.ifFeature("encore", "transparent"),
            fontWeight: f.ifFeature("encore", 400)
          }
        }
      },
      "&:focus": {
        backgroundColor: "transparent"
      },
      "&:hover": {
        backgroundColor: f.ifFeature("encore", a.surface.primary.weak, i.alpha(r.primary.lighter, 0.1)),
        // @startCleanup encore
        border: f.ifFeature("encore", void 0, i.border(1, r.primary.light)),
        // @endCleanup encore
        color: f.ifFeature("encore", a.text.primary.strong, r.grey[1e3]),
        fontWeight: f.ifFeature("encore", 600),
        zIndex: 2
      },
      "&.Mui-active": {
        "&:hover": {
          backgroundColor: f.ifFeature("encore", a.surface.primary.weak, i.alpha(r.primary.lighter, 0.9)),
          border: f.ifFeature("encore", "none")
        },
        color: f.ifFeature("encore", a.text.primary.strong, r.primary.contrastText),
        fontWeight: f.ifFeature("encore", 600),
        backgroundColor: f.ifFeature("encore", a.surface.primary.weak, i.alpha(r.primary.lighter, 0.9)),
        border: f.ifFeature(
          "encore",
          i.border(1, a.border.primary.strong),
          i.border(1, r.primary.light)
        ),
        "&.Mui-selected": {
          backgroundColor: f.ifFeature("encore", a.surface.primary.strong),
          color: f.ifFeature("encore", a.text.neutral.forcedWhite)
        },
        "&.Mui-error": {
          backgroundColor: f.ifFeature("encore", a.surface.error.strong, r.error.main),
          color: f.ifFeature("encore", a.text.neutral.forcedWhite),
          border: f.ifFeature("encore", i.border(1, a.border.error.medium))
        }
      },
      "&.FabricCalendarDay-marked": {
        "&:hover": {
          backgroundColor: i.alpha(r.primary.lighter, 0.9)
        },
        border: f.ifFeature(
          "encore",
          i.border(1, a.border.primary.medium),
          i.border(1, r.primary.light)
        ),
        color: f.ifFeature("encore", a.text.primary.strong),
        fontWeight: f.ifFeature("encore", 600),
        "&.Mui-active": {
          color: f.ifFeature("encore", a.text.neutral.inverted),
          fontWeight: f.ifFeature("encore", 700),
          backgroundColor: f.ifFeature("encore", a.surface.primary.strong)
        },
        "&.Mui-error": {
          backgroundColor: f.ifFeature("encore", a.surface.error.strong, r.error.main),
          color: f.ifFeature("encore", a.text.neutral.forcedWhite),
          "&.Mui-disabled": {
            border: f.ifFeature("encore", i.border(1, a.border.error.medium))
          }
        }
      },
      "&.FabricCalendarDay-inRange": {
        backgroundColor: f.ifFeature("encore", a.surface.primary.weak, i.alpha(r.primary.lightest, 0.1)),
        border: f.ifFeature("encore", void 0, i.border(1, i.alpha(r.primary.lightest, 0.5))),
        color: f.ifFeature("encore", a.text.primary.strong),
        "&.MuiPickersDay-today": {
          backgroundColor: f.ifFeature("encore", a.surface.primary.weak, i.alpha(r.primary.lighter, 0.2)),
          border: f.ifFeature(
            "encore",
            i.border(1, a.border.primary.medium),
            i.border(1, r.gray[400])
          )
        },
        "&.Mui-error": {
          color: f.ifFeature("encore", a.text.error.strong),
          border: i.border(1, r.error.main),
          backgroundColor: i.alpha(r.error.main, 0.1)
        }
      },
      "&.Mui-focused": {
        backgroundColor: f.ifFeature("encore", a.surface.primary.strong, `${r.primary.main} !important`),
        border: i.border(1, r.primary.light),
        color: `${r.primary.contrastText} !important`,
        fontWeight: f.ifFeature("encore", 600),
        zIndex: 2,
        "&.Mui-error": {
          backgroundColor: i.alpha(r.error.main, 0.2),
          borderColor: f.ifFeature("encore", a.surface.error.strong, r.error.main)
        }
      },
      "&.Mui-selected": {
        "&:hover": {
          backgroundColor: f.ifFeature("encore", a.surface.primary.weak, i.alpha(r.primary.lighter, 0.9)),
          color: f.ifFeature("encore", a.text.primary.strong)
        },
        // @startCleanup encore
        border: f.ifFeature("encore", void 0, i.border(1, r.primary.light)),
        // @endCleanup encore
        fontWeight: f.ifFeature("encore", 700),
        backgroundColor: f.ifFeature("encore", a.surface.primary.strong),
        "&.Mui-error": {
          backgroundColor: f.ifFeature("encore", a.surface.error.strong, r.error.main),
          color: f.ifFeature("encore", a.text.neutral.forcedWhite)
        }
      },
      "&.Mui-disabled": {
        color: f.ifFeature("encore", a.text.neutral.weak),
        backgroundColor: f.ifFeature("encore", a.surface.neutral.xxWeak),
        // @startCleanup encore
        "&.Mui-selected.Mui-error, &.FabricCalendarDay-marked.Mui-error": {
          color: f.ifFeature("encore", a.text.neutral.weak),
          backgroundColor: f.ifFeature("encore", a.surface.error.weak),
          fontWeight: f.ifFeature("encore", 600),
          border: f.ifFeature("encore", "none")
        }
        // @endCleanup encore
      }
    }
  };
}), rt = Xs("CalendarDay", [
  "active",
  "error",
  "inRange",
  "marked",
  "selected"
]), Dl = ({
  active: t,
  day: e,
  errored: n,
  marked: r,
  focused: s,
  selected: i,
  inRange: a,
  className: o,
  onKeyDown: u,
  onMouseEnter: l,
  ...c
}) => {
  const h = vs(), d = Vs(null), m = (w) => {
    l && l(w, {
      date: e
    });
  };
  js(() => {
    var w;
    s && ((w = d.current) == null || w.focus({ preventScroll: !0 }));
  }, [s]);
  const { classes: p } = Ml();
  return /* @__PURE__ */ y.jsx("div", { role: "gridcell", children: /* @__PURE__ */ y.jsx(
    Ns,
    {
      ...c,
      "aria-label": e ? e.toLocaleString({ dateStyle: "long" }) : void 0,
      className: ei(p.root, o, {
        [rt.error]: n,
        // Errored styling
        [rt.active]: t,
        // Focused styling
        [rt.inRange]: a,
        // Styling for items between ranges
        [rt.marked]: r,
        // Styling for original dates, start and end
        [rt.selected]: i
        // Styling for currently selected items; Either start or end
      }),
      "data-calendar-day": !0,
      day: e,
      onDayFocus: Be.noop,
      onMouseEnter: m,
      ref: d,
      tabIndex: t ? 0 : -1,
      children: f.ifFeature(
        "encore",
        /* @__PURE__ */ y.jsx(Qs, { size: "small", children: e && k(h, e) ? h.format(e, "dayOfMonth") : void 0 }),
        e && k(h, e) ? h.format(e, "dayOfMonth") : void 0
      )
    }
  ) });
}, or = "memoizeMode";
function kl(t) {
  const e = Be.omit(t, or);
  return /* @__PURE__ */ y.jsx(Dl, { ...e });
}
function xl(t, e) {
  if (e.memoizeMode === "quick")
    return t.focused === e.focused && t.inRange === e.inRange && t.selected === e.selected;
  const n = Be.omit(t, or), r = Be.omit(e, or);
  return Be.isEqual(n, r);
}
const Lc = fe.memo(
  kl,
  xl
), Sl = It()((t, e) => {
  const { constructs: n, mixins: r } = t, { hideLeftArrow: s, hideRightArrow: i } = e;
  return {
    root: {
      "&:nth-child(2)": {
        borderLeft: f.ifFeature("encore", r.border(1, n.border.neutral.xWeak))
      }
    },
    leftArrowButton: {
      visibility: s ? "hidden" : "visible"
    },
    rightArrowButton: {
      visibility: i ? "hidden" : "visible"
    }
  };
});
function Tl(t = [], e) {
  if (t.length !== 12)
    throw new Error("12 months are expected.");
  return t.map((n, r) => {
    const s = r + 1;
    return {
      isDisabled: e ? e(s) : !1,
      text: n,
      value: s
    };
  });
}
function Ol(t) {
  return {
    value: t[0]
  };
}
function Cl({
  disabled: t = !1,
  getMonthDisabled: e,
  months: n,
  onChange: r,
  onClose: s,
  onOpen: i,
  value: a
}) {
  const o = Tl(n, e);
  return /* @__PURE__ */ y.jsx(
    En,
    {
      "aria-label": window.jQuery ? $.__("Select Month") : "Select Month",
      isClearable: !1,
      isDisabled: t,
      items: o,
      onChange: u,
      onClose: s,
      onOpen: i,
      selectedValues: a ? [a] : void 0,
      showSearch: "never",
      size: "small",
      variant: f.ifFeature("encore", "single"),
      width: 1
    }
  );
  function u(l) {
    const c = Ol(l);
    r(c);
  }
}
function El(t, e, n, r, s, i) {
  if (!t || !e || !n)
    throw new Error("Expected arguments are missing.");
  const a = Ms(t, n, e);
  if (!a)
    throw new Error("Expected arguments are missing.");
  return i && (t.isSameMonth(i, a) || t.isSameMonth(s, a)) ? !1 : s && (t.isBeforeDay(s, a) || t.isAfterDay(i, a)) ? !0 : r ? r(a) : !1;
}
function Nl(t, e) {
  return {
    month: t,
    year: e
  };
}
function Fl(t, e, n) {
  if (!t || !e)
    throw new Error("Expected arguments are missing.");
  if (!n)
    return !1;
  for (let r = 0; r < 12; r++) {
    const s = t.date(new Date(e, r));
    if (!n(s))
      return !1;
  }
  return !0;
}
const Al = It()(() => ({
  months: {},
  root: {
    alignItems: "center",
    display: "flex",
    gap: f.ifFeature("encore", 5.33),
    margin: f.ifFeature("encore", "0 5.33px")
  },
  years: {
    // @startCleanup encore
    marginLeft: f.ifFeature("encore", void 0, 12)
    // @endCleanup encore
  }
})), Dn = ({
  disabled: t = !1,
  getDateDisabled: e,
  maxDate: n,
  minDate: r,
  months: s,
  monthsDisabled: i,
  monthValue: a,
  onChange: o,
  onMenuClose: u,
  onMenuOpen: l,
  years: c,
  yearsDisabled: h,
  yearValue: d
}) => {
  const { classes: m } = Al(), p = vs();
  return /* @__PURE__ */ y.jsxs("div", { className: m.root, children: [
    /* @__PURE__ */ y.jsx("div", { className: m.months, children: /* @__PURE__ */ y.jsx(
      Cl,
      {
        disabled: t || i,
        getMonthDisabled: (T) => El(p, T, d, e, n, r),
        months: s,
        onChange: w,
        onClose: u,
        onOpen: l,
        value: a
      }
    ) }),
    /* @__PURE__ */ y.jsx("div", { className: m.years, children: /* @__PURE__ */ y.jsx(
      Pl,
      {
        disabled: t || h,
        getYearDisabled: (T) => Fl(p, T, e),
        onChange: D,
        onClose: u,
        onOpen: l,
        value: d,
        years: c
      }
    ) })
  ] });
  function w(T) {
    S(T.value, d);
  }
  function D(T) {
    S(a, T.value);
  }
  function S(T, H) {
    const P = Nl(T, H);
    o(P);
  }
};
function Il(t = [], e) {
  return t.map((n) => ({
    isDisabled: e ? e(n) : !1,
    text: n.toString(),
    value: n
  }));
}
function Ll(t) {
  return {
    value: t[0]
  };
}
function Pl({
  disabled: t = !1,
  getYearDisabled: e,
  onChange: n,
  onOpen: r,
  onClose: s,
  value: i,
  years: a
}) {
  const o = Il(a, e);
  return /* @__PURE__ */ y.jsx(
    En,
    {
      "aria-label": window.jQuery ? $.__("Select Year") : "Select Year",
      isClearable: !1,
      isDisabled: t,
      items: o,
      onChange: u,
      onClose: s,
      onOpen: r,
      selectedValues: i ? [i] : void 0,
      showSearch: "never",
      size: "small",
      variant: f.ifFeature("encore", "single"),
      width: 1
    }
  );
  function u(l) {
    const c = Ll(l);
    n(c);
  }
}
const Pc = ({
  disabled: t,
  hideLeftArrow: e = !1,
  hideRightArrow: n = !1,
  maxDate: r,
  minDate: s,
  leftArrowDisabled: i,
  monthValue: a,
  months: o,
  onArrowClick: u,
  onChange: l,
  onMenuClose: c,
  onMenuOpen: h,
  rightArrowDisabled: d,
  yearValue: m,
  years: p
}) => {
  const { classes: w } = Sl({ hideLeftArrow: e, hideRightArrow: n });
  return f.ifFeature(
    "encore",
    /* @__PURE__ */ y.jsx("div", { className: w.root, children: /* @__PURE__ */ y.jsxs(ri, { alignItems: "flex-start", justifyContent: "space-between", children: [
      /* @__PURE__ */ y.jsx("div", { className: w.leftArrowButton, children: /* @__PURE__ */ y.jsx(
        Zr,
        {
          "aria-label": window.jQuery ? $.__("Previous Month") : "Previous Month",
          color: "primary",
          disabled: i,
          icon: "caret-left-solid",
          onClick: () => {
            u("previous-month");
          },
          size: "small",
          variant: "outlined"
        }
      ) }),
      /* @__PURE__ */ y.jsx(
        Dn,
        {
          disabled: t,
          maxDate: r,
          minDate: s,
          months: o,
          monthValue: a,
          onChange: l,
          onMenuClose: c,
          onMenuOpen: h,
          years: p,
          yearValue: m
        }
      ),
      /* @__PURE__ */ y.jsx("div", { className: w.rightArrowButton, children: /* @__PURE__ */ y.jsx(
        Zr,
        {
          "aria-label": window.jQuery ? $.__("Next Month") : "Next Month",
          color: "primary",
          disabled: d,
          icon: "caret-right-solid",
          onClick: () => {
            u("next-month");
          },
          size: "small",
          variant: "outlined"
        }
      ) })
    ] }) }),
    /* @__PURE__ */ y.jsxs(ti, { justifyContent: "space-between", children: [
      /* @__PURE__ */ y.jsx("div", { className: w.leftArrowButton, children: /* @__PURE__ */ y.jsx(
        Ur,
        {
          "aria-label": window.jQuery ? $.__("Previous Month") : "Previous Month",
          disabled: i,
          icon: f.ifFeature("encore", "arrow-left-solid", /* @__PURE__ */ y.jsx(Nn, {})),
          onClick: () => {
            u("previous-month");
          },
          outline: !0,
          secondary: !0
        }
      ) }),
      /* @__PURE__ */ y.jsx(
        Dn,
        {
          disabled: t,
          maxDate: r,
          minDate: s,
          months: o,
          monthValue: a,
          onChange: l,
          onMenuClose: c,
          onMenuOpen: h,
          years: p,
          yearValue: m
        }
      ),
      /* @__PURE__ */ y.jsx("div", { className: w.rightArrowButton, children: /* @__PURE__ */ y.jsx(
        Ur,
        {
          "aria-label": window.jQuery ? $.__("Next Month") : "Next Month",
          disabled: d,
          icon: f.ifFeature("encore", "arrow-right-solid", /* @__PURE__ */ y.jsx(Fn, {})),
          onClick: () => {
            u("next-month");
          },
          outline: !0,
          secondary: !0
        }
      ) })
    ] })
  );
};
function Rc({ children: t }) {
  const { formatType: e, locale: n } = kn(Cn);
  return /* @__PURE__ */ y.jsx(
    tu,
    {
      adapterLocale: n,
      dateAdapter: Co,
      dateFormats: { fullDate: e, isoDate: "yyyy-MM-dd" },
      children: t
    }
  );
}
export {
  Ao as A,
  Mc as B,
  Ic as C,
  Co as D,
  Fc as E,
  ko as F,
  vo as G,
  Mo as H,
  jr as I,
  dc as J,
  Vo as K,
  jo as L,
  Sc as M,
  Nc as N,
  $o as O,
  Dc as P,
  Ec as Q,
  kc as R,
  Rc as a,
  mc as b,
  gc as c,
  yc as d,
  At as e,
  k as f,
  hc as g,
  bc as h,
  wc as i,
  Ds as j,
  Wr as k,
  Cc as l,
  Oc as m,
  Tc as n,
  Fo as o,
  fc as p,
  Pc as q,
  b as r,
  Ms as s,
  bo as t,
  vs as u,
  pc as v,
  Lc as w,
  vc as x,
  Ac as y,
  xc as z
};
//# sourceMappingURL=date-picker-utils-provider-CwC1AjFc.mjs.map
